<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable no-unused-vars -->

<template>
  <!-- partial -->
  <div class="main-panel">
    <div class="content-wrapper dashboard-shell">
      <div class="cardplay solicitud-shell">
        <div class="card-body solicitud-card-body">
          <form-tag @ClienteEditEvent="submitHandler" name="clienteForm" event="clienteEditEvent" id="cliente-form">
            <div class="row dashboard-header g-3 align-items-center mb-4">
              <div class="col-12 col-lg-7">
                <h2 v-if="this.idSolicitud > 0" class="dashboard-title mb-1">
                </h2>
                <h2 v-else class="dashboard-title mb-1">
                </h2>
                <p class="solicitud-subtitle mb-0">
                  Completa y gestiona esta solicitud con un flujo claro, amigable y ordenado.
                </p>
              </div>

              <div class="col-lg-5 col-12 d-flex align-items-start justify-content-lg-end" style="height: 90%">
                <span class="solicitud-badge me-lg-3 mb-2 mb-lg-0">{{ this.idSolicitud > 0 ? 'Edición activa' : 'Paso inicial' }}</span>
              </div>
            </div>

            <div class="row mb-3 d-flex justify-content-center align-item-center">
              <div class="col-lg-12 col-12 d-flex align-items-start justify-content-end" style="height: 90%">
                <input v-if="this.idSolicitud <= 0" type="submit" class="btn btn-dark solicitud-main-btn" value="Guardar" />
                <div class="btnOptionSolicitud" v-else>
                  <select v-model="reportes" class="form-select report-select" name="reportes" aria-label="Default select example">
                    <option>Reportes</option>
                    <option value="reporte1">Exportar Solicitud <i class="fa-solid fa-download"></i></option>
                    <option value="reporte2" v-if="this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Otorgado'">Exportar Contrato <i class="fa-solid fa-download"></i></option>
                    <option value="reporte3" v-if="this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Otorgado'">Exportar Pagaré <i class="fa-solid fa-download"></i></option>
                  </select>
                  <button v-if="this.solicitud.estado !== 'Aprobado' && this.solicitud.estado !== 'Otorgado'"
                    type="submit" class="btn btn-primary d-flex justify-content-center align-item-center solicitud-main-btn">
                    Actualizar <i class="fa-solid fa-floppy-disk ms-2"></i>
                  </button>
                  <button v-else-if="this.userRoles[0].some(role => role === 'Modo Thanos') || this.userRoles[0].some(role => role === 'Asesor')" type="submit"
                    class="btn btn-primary d-flex justify-content-center align-item-center solicitud-main-btn">
                    Actualizar <i class="fa-solid fa-floppy-disk ms-2"></i>
                  </button>
                  <div v-if="this.Asesor !== true">
                    <button type="button" v-if="this.solicitud.estado === 'Pendiente'" class="btn btn-warning"
                      data-bs-toggle="modal" data-bs-target="#estadoSolicitud">
                      Estado {{ this.solicitud.estado }}
                    </button>
                    <button type="button"
                      v-else-if="(this.solicitud.estado === 'Aprobado') && (this.Admin || this.Coordinacion)"
                      class="btn btn-success" data-bs-toggle="modal" data-bs-target="#estadoSolicitud">
                      Estado {{ this.solicitud.estado }}
                    </button>
                    <button type="button" v-else-if="this.solicitud.estado === 'Aprobado'" class="btn btn-success"
                      disabled>
                      Estado {{ this.solicitud.estado }}
                    </button>
                    <button type="button"
                      v-else-if="this.solicitud.estado === 'Rechazado' && (this.Admin || this.Coordinacion)"
                      class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#estadoSolicitud">
                      Estado {{ this.solicitud.estado }}
                    </button>
                    <button type="button" v-else-if="this.solicitud.estado === 'Rechazado'" class="btn btn-danger"
                      data-bs-toggle="modal" data-bs-target="#estadoSolicitud" disabled>
                      Estado {{ this.solicitud.estado }}
                    </button>
                    <button type="button" v-else-if="this.solicitud.estado === 'Otorgado'" class="btn btn-dark"
                      disabled>
                      Estado {{ this.solicitud.estado }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
                <div class="accordion solicitud-accordion" id="accordionPanelsStayOpenExample">
                  <!-- Aqui va datos Solicitante -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="data-headingOne">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#datos-collapseOne" aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne">
                        <div class="col-6">Datos Solicitante</div>
                        <div id="validar-1" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="datos-collapseOne" class="accordion-collapse collapse show"
                      aria-labelledby="data-headingOne">
                      <div class="accordion-body">

                        <!-- FICHA DE BENEFICIARIO -->
                        <div class="container-fluid p-0 ">
                          <!-- <h4 class="display-4">Ficha de Beneficiario</h4> -->

                            <div class="row">
                          <div v-if="this.idSolicitud <= 0" class="col-12 col-lg-4 mt-1">
                            <p class="ms-3 mb-1">Busca por DNI</p>
                            <input v-model="dni" @input="formatInput" placeholder="Ejemplo: 0801-1998-02195"
                              class="form-control" style="height: 20px" type="text" minlength="15" maxlength="15"
                              id="dni" required />

                              <div v-if="this.cliente && Object.keys(this.cliente).length > 0">
                                <button @click="irASolicitante(this.cliente)" class="btn btn-primary w-100 mt-2">
                                  Actualizar y Validar Beneficiario 
                                </button>
                              </div>
                              <div v-else>
                                 <router-link class="nav-link w-100" to="/solicitante/nuevo">Crear Nuevo
                                  Beneficiario</router-link>
                              </div>

                            <p v-if="this.store.aprobacion.validacion" class="text-success mt-4">
                              Validado <i class="fa-solid fa-circle-check"></i>
                            </p>

                          </div>
                          
                          <div v-if="this.cliente" :class="(this.idSolicitud <= 0)?'info-clientes col-12 col-lg-8 mt-3 mt-lg-0':'' ">
                            <div class="row">
                            <div    class="col-7 mt-2 d-flex flex-column justify-content-center align-item-center">
                            <div class="d-flex justify-content-between justify-content-center align-item-center">
                              {{ this.cliente.nombres }} {{ this.cliente.apellidos }}
                            </div>
                            <strong class="mt-1">{{ this.cliente.dni }}</strong>  
                            
                            <div class="d-flex mt-3 justify-content-between justify-content-center align-item-center extra-info">
                            <p>RTN:</p> <p>{{ this.cliente.rtn }}</p>
                            </div>
                            <div class="d-flex justify-content-between justify-content-center align-item-center extra-info">
                            <p>No Teléfono: </p> <p>{{ this.cliente.celular }}</p>
                            </div>
                            <div class="d-flex justify-content-between justify-content-center align-item-center extra-info">
                            <p>No Teléfono Negocio: </p> <p>{{ this.cliente.telefono }}</p>
                            </div>
                            </div>

                            <div class="col-5 d-flex justify-content-center align-item-center">
                              
                              <!-- <div v-if="this.cliente.foto" class="foto-cliente d-flex justify-content-center align-item-center">
                                <img :src="this.cliente.foto" alt="Foto Cliente" style="width: 100px; height: 100px; object-fit: cover; border-radius: 50%;" />
                              </div> -->
                              <!-- <div v-else class="foto-cliente d-flex justify-content-center align-item-center">
                                <img src="/assets/images/faces/face1.jpg" alt="Foto Cliente" style="width: 100px; height: 100px; object-fit: cover; border-radius: 50%;" />
                              </div> -->
                              <!-- <div class="con-foto">
                                <i class="fa-solid fa-user"></i>
                              </div> -->
                              <!-- {{this.FotoCliente}} -->
                              <div class="sin-foto">
                                <img v-if="this.FotoCliente != ''" :src="'data:image/png;base64,'+this.FotoCliente" alt="Foto Cliente" style=" border-radius: 5px; height: 100%; object-fit: cover;" />

                                <i v-else class="fa-solid fa-user"></i>
                              </div>
                            </div>
                            </div>
                          </div>                           

                          <!-- {{ this.score }} {{ this.claseScore }} -->
                          <button v-if="cliente " class="btn btn-dark ms-3" type="button" @click="viewScore = !viewScore" style="width: 200px; margin-top: 15px;">
                            {{(!viewScore)?'Ver Puntaje de Crédito':'Ocultar Puntaje de Crédito'}}
                          </button>

                          
                          
                          <div v-if="cliente && viewScore" class="row rounded p-3 mt-3 m-5" style="background: #f8f9fa; width: 90%">
                              <h4 class="mt-3 mb-2 ms-5">Puntaje de Crédito</h4>

                            <div  class="col-12 ">
                              <ScoreDetails
                                :puntaje_equifax="cliente.puntaje_equifax"
                                :ingresos_mensuales="cliente.ingresos_mensuales"
                                :dti="cliente.dti"
                                :antiguedad_cantidad="cliente.antiguedad_cantidad"
                                :antiguedad_unidad="cliente.antiguedad_unidad"
                                :garantia="cliente.garantia"
                                :comportamiento="cliente.comportamiento"
                                currency="Lps"
                                v-model:score="this.score"
                                v-model:class="this.claseScore"
                              />

                            </div>

                          <p v-if="cliente && score <= 6" class="text-danger ms-3 mt-3">
                            Puntaje de Crédito necesita ser llenado
                          </p>
                          </div>
                          




                        </div>

                        
                        </div>

                      </div>
                    </div>
                  </div>
                  
                  <!-- Aqui va condiciones Credito -->
                  <CondicionesCredito
                    :solicitud="solicitud"
                    :solicitud-completa="solicitudCompleta"
                    :productos-seleccionables="productosSeleccionables"
                    :departamentos="departamentos"
                    :pagos-interes="pagosInteres"
                    :cliente="cliente"
                    :producto-seleccionado-id="productoSeleccionadoId"
                    :producto-seleccionado-nombre="productoSeleccionadoNombre"
                    :monto-otorgar="montoOtorgar"
                    :arreglo-pago-intereses="arregloPagoIntereses"
                    :monto-a-p-interes="montoAPInteres"
                    :no-pagos-a-p-interes="noPagosAPInteres"
                    :validar-pagos-interes="validarPagosInteres"
                    :productos-ready="productosReady"
                    :productos-error="productosError"
                    :producto-config-loading="productoConfigLoading"
                    :producto-config-error="productoConfigError"
                    :modo-thanos="modoThanos"
                    :es-credi-trabajo2="creditrabajo2()"
                    :es-crea-futuro="creaFuturo()"
                    :es-micro-credito="microCredito()"
                    :moneda="moneda"
                    :monto-interes="montoInteres"
                    :comision-otorgamiento="comisionOtorgamiento"
                    :total-comision-otorgamiento="totalComisionOtorgamiento"
                    :comision-asistencia-tecnica="comisionAsistenciaTecnica"
                    :total-comision-asistencia-tecnica="totalComisionAsistenciaTecnica"
                    :tasa-seguridad="tasaSeguridad"
                    :total-tasa-seguridad="totalTasaSeguridad"
                    :reservas-seguros="reservasSeguros"
                    :total-reservas-seguros="totalReservasSeguros"
                    :consultas-buro="consultasBuro"
                    :total-consultas-buro="totalConsultasBuro"
                    :cobro-por-a-c-h="cobroPorACH"
                    @update:producto-seleccionado-id="productoSeleccionadoId = $event"
                    @update:monto-otorgar="montoOtorgar = $event"
                    @update:arreglo-pago-intereses="arregloPagoIntereses = $event"
                    @update:monto-a-p-interes="montoAPInteres = $event"
                    @update:no-pagos-a-p-interes="noPagosAPInteres = $event"
                    @seleccionar-producto="seleccionarProductoPorId"
                    @blur-monto="onBlur"
                    @generar-pagos-interes="generarPagosInteres"
                    @validacion-monto="montoAprobadoValido = $event"
                    @validacion-interes="interesAnualValido = $event"
                    @validacion-mora="tasaMoraValida = $event"
                    @validacion-plazo="plazoPagoValido = $event"
                  />
                  <div v-if="this.store.aprobacion.validacion">



                  <!-- Información de Solicitud -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseLast" aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseLast">
                        <div class="col-6">Información de Solicitud</div>
                        <div id="validar-8" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseLast" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingOne">
                      <div class="accordion-body">
                        <div class="solicitud-info-layout">
                          <div class="solicitud-info-panel garantia-panel">
                            <div class="solicitud-info-heading">
                              <span class="solicitud-info-icon">
                                <i class="fa-solid fa-shield-halved"></i>
                              </span>
                              <div>
                                <p class="solicitud-info-kicker mb-1">Respaldo del crédito</p>
                                <h5 class="solicitud-info-title mb-0">Garantía</h5>
                              </div>
                            </div>

                            <label for="garantia" class="form-label solicitud-info-label">Tipo de garantía</label>
                            <select :required="(this.modoThanos === true) ? false : true" v-model="solicitud.garantia"
                              :value="solicitud.garantia" class="form-control solicitud-info-select" id="garantia" name="garantia">
                              <option value="Garantía Fiduciaria">Garantía Fiduciaria</option>
                              <option value="Aval Comerciante">Aval Comerciante </option>
                              <option value="Garantía Mobiliaria">Garantía Mobiliaria</option>
                              <option value="Garantía Prendaria">Garantía Prendaria </option>
                              <option value="Garantía Hipotecaria">Garantía Hipotecaria </option>
                              <option value="Grupo Solidario">Grupo Solidario </option>
                            </select>

                            <div class="garantia-requisitos">
                              <div class="garantia-requisitos-header">
                                <span><i class="fa-solid fa-list-check"></i></span>
                                <strong>Requisitos sugeridos</strong>
                              </div>
                              <div id="info_garantia" class="mt-3"></div>
                            </div>
                          </div>

                          <div class="solicitud-info-panel referencias-panel">
                            <div class="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-3">
                              <div class="solicitud-info-heading mb-0">
                                <span class="solicitud-info-icon referencias-icon">
                                  <i class="fa-solid fa-address-book"></i>
                                </span>
                                <div>
                                  <p class="solicitud-info-kicker mb-1">Contactos de verificación</p>
                                  <h5 class="referencia-title mb-0">Referencias</h5>
                                </div>
                              </div>
                              <button type="button" class="btn add-referencia-btn btn-sm" @click="agregarReferencia">
                                <i class="fa-solid fa-plus"></i>
                                <span>Agregar</span>
                              </button>
                            </div>

                            <div v-for="(referencia, index) in solicitud.referencias" :key="`referencia-${index}`"
                              class="referencia-box mb-3">
                              <div class="referencia-box-header">
                                <div class="referencia-number">
                                  <span>{{ index + 1 }}</span>
                                  <strong>Referencia</strong>
                                </div>
                                <button v-if="solicitud.referencias.length > 1" type="button"
                                  class="btn remove-referencia-btn btn-sm" @click="eliminarReferencia(index)" title="Eliminar referencia">
                                  <i class="fa-solid fa-trash"></i>
                                </button>
                              </div>

                              <div class="row g-2">
                                <div class="col-12 col-md-4">
                                  <label class="form-label">Tipo</label>
                                  <select v-model="referencia.tipoReferencia"
                                    @change="referencia.parentescoORelacion = ''"
                                    class="form-control referencia-control" name="referenciaTipo">
                                    <option value="">Seleccionar</option>
                                    <option value="Familiar">Familiar</option>
                                    <option value="Personal">Personal</option>
                                  </select>
                                </div>
                                <div class="col-12 col-md-8">
                                  <label class="form-label">Nombre completo</label>
                                  <input v-model="referencia.nombreCompleto" type="text"
                                    class="form-control referencia-control" name="referenciaNombre" />
                                </div>
                                <div class="col-12 col-md-6">
                                  <label class="form-label">Parentesco o relación</label>
                                  <select v-model="referencia.parentescoORelacion"
                                    class="form-control referencia-control" name="referenciaParentesco">
                                    <option value="">Seleccione</option>
                                    <option v-for="opcion in obtenerOpcionesParentesco(referencia.tipoReferencia)"
                                      :key="opcion" :value="opcion">
                                      {{ opcion }}
                                    </option>
                                  </select>
                                </div>
                                <div class="col-12 col-md-6">
                                  <label class="form-label">Teléfono</label>
                                  <input v-model="referencia.telefono" type="text"
                                    class="form-control referencia-control" name="referenciaTelefono" />
                                </div>
                                <div class="col-12">
                                  <label class="form-label">Dirección</label>
                                  <textarea v-model="referencia.direccion" class="form-control referencia-control"
                                    name="referenciaDireccion" rows="2"></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Gestión de Archivos -->
                  <div v-if="this.$route.params.solicitudId > 0" class="accordion-item" >
                    <h2 class="accordion-header" id="panelsStayOpen-headingOne9">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseLast9" aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseLast9">
                        <div class="col-6">Gestión de archivos y Validación de documentos</div>
                        <div id="validar-8" class="d-flex justify-content-end me-3" style="width: 100%"></div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseLast9" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingOne9">
                      <div  class="accordion-body">

                        <!-- Aqui abre la gestion de archivos -->
                      <a :href="'/archivos/' + this.$route.params.solicitudId" class="folder" target="_blank">
                        <i class="fa-solid fa-folder-open"></i>
                      </a>
                      <div class="d-flex justify-content-between align-items-center mt-2">
                        <h4 class="pt-2">Validación de Archivos</h4> 
                        <button class="btn btn-primary d-flex align-items-center " @click="reloadInfoArchivos(this.$route.params.solicitudId)" type="button" >
                          Recargar <i class=" ms-2 fa-solid fa-rotate-right"></i>
                        </button>
                      </div>
                      <div v-if="this.readyArchivos" class="mt-2">
                      <!-- {{this.contadorArchivos}} -->

                        <div class="d-flex">
                          Fotografía del DNI 
                          <div v-if="this.contadorArchivos.dni > 0">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;"></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          Fachada del Negocio
                          <div v-if="this.contadorArchivos.fachada > 0">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;" ></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div>
                        <div class="d-flex">
                          Fachada de la Casa
                          <div v-if="this.contadorArchivos.fachadacasa > 0">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;"></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div>
                        <!-- <div class="d-flex">
                          Validacion de asesor(FIRMA)
                          <div v-if="this.autorizadofirma">
                            <i class="fa-solid fa-circle-check ms-2" style="color:green;"></i>
                          </div>
                          <div v-else>
                            <i class="fa-solid fa-circle-xmark ms-2" style="color:red;"></i>
                          </div>
                        </div> -->
                        
                        
                        
                      </div>

                      <div class="nota">
                        <p class="mt-3">Nota: La Fotografía del DNI, Fachada del Negocio y Fachada de la Casa se muestran como referencia y ya no bloquean la aprobación del crédito.</p>
                      </div>

                      <!-- <div class="contenedor mt-3 ">

                        <div class="row">
                          <h4 class="display-4">Autorización por Firma</h4>
                          <p>Por favor, capture su firma digital para continuar con el proceso de aprobación del crédito.</p>
                          <p>Una vez capturada, la firma se guardará y se mostrará a continuación.</p>
                        </div>

                        <button @click="exportarSolicitudPDF('FIRMA')" type="button" class="btn btn-secondary mt-3">
                        Iniciar proceso de firmado <i class="fa-solid fa-download"></i>
                      </button> -->
                        <!-- <div class="row mt-2">

                        <div v-if="!this.autorizadofirma" class="col-12 col-md-6">
                        <ComponenteFirma
                          @firmaGuardada="guardarFirma"
                          @firmaVacia="mostrarAlerta"
                          :idSolicitud="this.$route.params.solicitudId"
                        />
                        </div>

                        <div class="col-12 col-md-6" v-if="firmaBase64">
                          <h3 class="display-4">Firma capturada:</h3>
                          <img :src="firmaBase64" alt="Firma digital" />
                        </div>
                        </div> -->
                      <!-- </div> -->


                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingSummaryTable">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseSummaryTable" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseSummaryTable">
                        <div class="col-6">
                          Resumen del Crédito
                        </div>
                        <div id="validar-2" class="d-flex justify-content-end me-3" style="width: 100%">

                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseSummaryTable" class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingSummaryTable">
                      <div class="accordion-body">
                        <div class="container" id="content">
                          <hr>
                          <table class="datos-table">

                            <tr>
                              <td> <b>Nombre:</b> </td>
                              <td>{{ this.cliente?.nombres }} {{ this.cliente?.apellidos }}</td>
                              <td><b>ID Beneficiario:</b> </td>
                              <td>{{ this.cliente?.dni }}</td>
                            </tr>
                            <tr>
                              <td><b>Producto:</b> </td>
                              <td>{{ this.solicitud?.producto }}</td>
                              <td><b>Número de préstamo:</b> </td>
                              <td>AHDE-{{ this.solicitud?.id }}</td>
                            </tr>
                            <tr>
                              <td> <b> IFI: </b> </td>
                              <td>{{ this.cliente?.nombreBanco }}</td>
                              <td><b>Cuenta depósito:</b> </td>
                              <td>{{ this.cliente?.noCuentaBanco }}</td>
                            </tr>
                          </table>
                          <hr />
                          <table class="datos-prestamo-table custom-table">
                            <tr>
                              <td><b>Fecha Apertura:</b></td>
                              <!-- <td colspan="1">{{ new Date(this.solicitud?.fechaPago).toLocaleDateString('en-GB') }}</td> -->
                              <td colspan="1">{{ new Date(this.solicitud?.fechaPago).toLocaleDateString('en-GB', {
                                timeZone: 'UTC'
                              }) }}</td>

                              <td><b>Monto Aprobado:</b></td>
                              <td>{{ formatoNumero(this.solicitud.monto) }} {{ this.moneda }}</td>

                              <td></td>
                            </tr>
                            <tr>
                              <td><b>Tasa Interes:</b></td>
                              <td>{{ this.solicitud?.interes }}%</td>
                              <td><b>Plazo (meses):</b></td>
                              <td>{{ this.solicitud?.plazoPago }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td><b>Forma de pago:</b></td>
                              <td>{{ this.solicitud?.frecuenciaPago }}</td>
                              <td><b>Moneda:</b></td>
                              <td>Lempiras</td>
                              <td></td>
                            </tr>
                            <tr v-if="this.solicitud.producto === 'Credi Trabajo'">
                              <td><b> Total Interes: </b></td>
                              <td>{{ (this.solicitud?.monto * ((this.solicitud?.interes / 12) /
                                100) * this.solicitud.plazoPago).toLocaleString('en-US', minimumFractionDigits = 2,
                                  maximumFractionDigits = 2) }}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>

                            <tr>
                              <td colspan="1"><b>Tipo de cálculo:</b></td>
                              <td>Cuota Nivelada</td>
                              <td><b>Periodo Base:</b></td>
                              <td>360</td>
                              <td></td>
                            </tr>


                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>


                </div>
              </form-tag>
              <!-- MODAL PARA CAMBIAR ESTADO DE LA SOLICITUD -->
              <div class="modal fade" id="estadoSolicitud" tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">Estado de la Solicitud</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    
                    <EstadoSolicitud ref="estadoComp" :idSolicitud="idSolicitud" :autorizadoFirma="this.autorizadofirma" />

                  </div>
                </div>
              </div>
        </div>
      </div>
    </div>
    <!-- content-wrapper ends -->
    <!-- partial:../../partials/_footer.html -->
    <footer class="footer">
      <div class="d-sm-flex justify-content-center justify-content-sm-between">
        <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright ©
          AXUM 2026</span>
      </div>
    </footer>
    <!-- partial -->
  </div>
</template>
<script>
import Security from "../security";
import FormTag from "@/components/forms/Form-Tag-Pagos.vue";
import { solicitudCompleta } from "../solicitud";
import router from "../../router/index.js";
import Swal from "sweetalert2";
import EstadoSolicitud from "../forms/EstadoSolicitud.vue";
// import direccionData from './direccionData.json';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { exportacionContratos } from './ExportacionContratos'
import { exportacionPagares } from './ExportacionPagare'
import CondicionesCredito from "./CondicionesCredito.vue";
import { store } from '../store';
// import CreditScoreGauge from "../score/CreditScoreGauge.vue";
import ScoreDetails from "../score/ScoreDetails.vue";
// import PlanPagos from '../plan-pagos.vue';
//import ComponenteFirma from '../SignaturePad.vue'

// ScoreDetails
export default {
  name: "NuevaSolicitud",
  components: {
    "form-tag": FormTag,
    // "plan-pagos": PlanPagos,
    EstadoSolicitud,
    CondicionesCredito,
    ScoreDetails,
    // CreditScoreGauge,
    //ComponenteFirma,
  },
  data() {
    return {
      productSelect: {},
      dniAnterior: "",

      viewScore: true,
      clase: "",
      puntaje: 70,
      FotoCliente: "",
      score: 0,
      claseScore: "",
      // Firma

      firmaBase64: null,
      autorizadofirma: false,

      store,
      // Firma

      reportes:"Reportes",

      // Arreglo de Pago Intereses
      arregloPagoIntereses: false,
 
      montoAPInteres: 0.0,
      noPagosAPInteres: 0,
      pagosInteres: [],
      validarPagosInteres: false,
      montoAprobadoValido: true,
      interesAnualValido: true,
      tasaMoraValida: true,
      plazoPagoValido: true,

      exportacionContratos,
      exportacionPagares,
      departamentos: [],
      departamentoSeleccionado: null,
      planPagoToPrint: [],
      comisionOtorgamiento: 0.0,
      montoComisionOtorgamiento: 0.0,
      totalComisionOtorgamiento: 0.0,
      totalReservasSeguros: 0.0,
      comisionAsistenciaTecnica: 0.0,
      totalComisionAsistenciaTecnica: 0.0,
      tasaSeguridad: 0.00,
      reservasSeguros: 0.0,
      consultasBuro: 0.0,
      totalTasaSeguridad: 0.0,
      totalConsultasBuro: 0.0,
      cobroPorACH: 40.0,
      montoNeto: 0,
      montoInteres: 0.0,
      idSolicitud: 0,
      validarAcordion: "",
      solicitudCompleta,
      productos: [],
      productosReady: false,
      productosError: false,
      productoSeleccionadoId: "",
      productoConfigLoading: false,
      productoConfigError: false,
      fechaNacimiento: "",
      edadsoli: "",
      estadoCivil: "",
      final: false,
      noReferencias: 1,
      dni: "",
     contadorArchivos: {},
             readyArchivos: false,

      cliente: {},
      fechaVencimiento: '',
      solicitud: {
        ID: 0,
        clienteId: 0,
        producto: "",
        frecuenciaPagoGracia: "",

        pagosInteres: [],
        validarPagosInteres: false,

        fechaPago: (new Date()).toISOString().slice(0, 10),
        monto: '0',
        montoOtorgar: '0.0',
        frecuenciaPago: "",
        interes: "",
        tasaMora: "",
        tipoPlazo: "mensual",
        plazoPago: '',
        fechaFija: false,
        garantia: '',
        referencias: [
          {
            id: 0,
            idSolicitud: 0,
            tipoReferencia: "",
            nombreCompleto: "",
            parentescoORelacion: "",
            direccion: "",
            telefono: "",
          },
        ],
        estado: '',
        sucursalId: 0,
        sucursal: "",
      },
      montoOtorgar: "",
      moneda: 'lps',
      // comisionOtorgamiento: 0,
      // comisionAsistenciaTecnica: 0,
      // tasaSeguridad: 0,
      userRoles: [],
      Asesor: false,
      cuotaSolicitud: 0,

      SumaCuotaTotal: 0,
      SumaInteres: 0,
      SumaCapital: 0,
      SumaSaldo: 0,

      sinMora: false,

      // Roles
      roles: ['Coordinacion', 'Admin', 'Finanzas', 'Asesor', 'Cordinador Sucursal', 'Consultor'],
      Finanzas: false,
      Admin: false,
      Coordinacion: false,
      coordinadorSucursal: false,
      modoThanos: false,
      Consultor: false,
    };
  },
  beforeMount() {

    
    
    this.idSolicitud = this.$route.params.solicitudId
    this.fetchProductos();
    this.fetchSucursales();
  if(this.idSolicitud > 0){
    store.aprobacion.validacion = true;
  }
    // this.departamentos = direccionData[0].departamentos

    this.userRoles = Security.getUserRoles();
    // console.log(this.userRoles);
    this.roles.forEach(element => {

      if (this.userRoles[0]?.some(role => role.includes(element)) === true) {
        this[element] = true;
      } else if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
        this.coordinadorSucursal = true;
        // console.log('coordinador sucursal en true')
      } else if (this.userRoles[0]?.some(role => role.includes('Modo Thanos')) === true) {
        this.modoThanos = true;
        // console.log('Modo thanos en true')
      }
      /*       if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
            } */


    });

    // Obtener GrupoSolidario por edit is id > 0
    if (this.idSolicitud > 0) {
      //editing a solicitante
      fetch(
        process.env.VUE_APP_API_URL +
        "/admin/solicitud/" +
        this.$route.params.solicitudId,
        Security.requestOptions("")
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit("error", data.message);
          } else {
            // this.Grupo = data.data;
            console.log("Dataa:", data.data[0].cliente);  
            
            if (!this.creditrabajo2() && !this.creaFuturo()) {

              let currentSol = data.data.find((sol) => sol.id == this.$route.params.solicitudId)
              this.solicitud = currentSol
              this.solicitud.fechaPago = currentSol.fechaPago
              this.solicitud.frecuenciaPago = currentSol.frecuenciaPago.toLowerCase()
              this.solicitud.referencias = this.prepararReferenciasParaFormulario(currentSol.referencias)
              this.cliente = currentSol.cliente
              // this.dni = data.data.dni;
              // this.cliente.estado = data.data.estado;
              this.solicitudCompleta.producto = (this.solicitud.producto)
              this.sincronizarProductoSeleccionado(true);
              this.comisionAsistenciaTecnica = 3.50
              this.comisionOtorgamiento = 2.50
              this.tasaSeguridad = 0.40
              this.montoOtorgar = this.solicitud.montoOtorgar
              if(this.creaFuturo()){
              console.log("Es Crea Futuro")
                this.onBlur()
              }
              this.totalComisionOtorgamiento = this.solicitud.monto * (this.comisionOtorgamiento / 100)
              this.totalComisionAsistenciaTecnica = this.solicitud.monto * (this.comisionAsistenciaTecnica / 100)
              this.totalTasaSeguridad = this.solicitud.monto * (this.tasaSeguridad / 100)
              this.montoNeto = this.solicitud.monto - this.totalComisionOtorgamiento - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad
              // this.fechaPago = this.solicitud.fechaPago.length < 10 ? ((new Date()).toISOString().slice(0,10)) : this.solicitud.fechaPago
              this.fechaPago = (new Date()).toISOString().slice(0, 10)
              console.log(this.solicitud)

              
              this.FotoBenficiario(this.cliente.dni)
              // Pago Intereses
              // Logica para calcular el monto y la cantidad de pagos de intereses

              if (this.solicitud.pagosInteres == null) {
                this.solicitud.pagosInteres = []
              } else { 

                this.pagosInteres = this.solicitud.pagosInteres
              }
              if (this.pagosInteres.length > 0) {
                this.arregloPagoIntereses = true

                for (let i = 0; i < this.solicitud.pagosInteres.length; i++) {
                  const element = this.solicitud.pagosInteres[i];

                  this.montoAPInteres += element.monto
                  this.noPagosAPInteres += 1

                  this.solicitud.pagosInteres[i].fecha = this.convertirISOaFechaCorta(this.solicitud.pagosInteres[i].fecha)

                }
              }

              this.montoAPInteres= this.montoAPInteres.toFixed(2)


               console.log("Solicitud Completa en Nueva Solicitud:", this.solicitud);
    this.cuotaSolicitud = this.obtenerCuotaTotal({
      monto: this.solicitud.monto,
      frecuenciaPago: this.solicitud.frecuenciaPago,
      interesAnual: this.solicitud.interes,
      plazo: this.solicitud.plazoPago,
      producto: this.solicitud.producto,
      periodoGracia: this.solicitud.periodoGracia || 0
    });
    console.log("Cuota:", this.cuotaSolicitud);


            } else {

              console.log("Data", data.data);

            }

            this.getCountArchivos(this.solicitud.id);
            this.getFirma(this.solicitud.id);
          }
        });
    } else if (this.getProductoNombre(solicitudCompleta.producto) == "") {
      // router.push("/solicitud");
      // location.reload();
      // window.location.href = "/solicitud";
      this.setProductoInicial();
    }
    // if (this.validarMiPyme) {
    //   this.solicitudCompleta.integranteSolicitud+2
    // }
    if (this.creditrabajo2) {
      this.solicitud.frecuenciaPago = 'semanal'
    }

    
    
  },
  mounted() {
    Security.requireToken();

    this.cliente =
      this.solicitudCompleta.integrantes[
      this.solicitudCompleta.integranteSolicitud
      ];

    if (this.cliente && Object.keys(this.cliente).length > 0) {
        this.dni = this.formatDNI(this.cliente.dni) ;
        // this.dni = this.cliente.dni;
      }

      const dniDesdeCliente = String(this.$route.query.dni || "").replace(/\D/g, "").slice(0, 13);
      if (this.idSolicitud <= 0 && dniDesdeCliente.length === 13) {
        this.store.aprobacion.validacion = this.$route.query.validado === "1";
        this.solicitudCompleta.integrantes.splice(0);
        this.solicitudCompleta.dniIntegrantes.splice(0);
        this.solicitudCompleta.integranteSolicitud = 0;
        this.dniAnterior = "";
        this.dni = this.formatDNI(dniDesdeCliente);
      }

      const modalEl = document.getElementById('estadoSolicitud');
      if (modalEl) {
        modalEl.addEventListener('show.bs.modal', () => {
          if (this.$refs.estadoComp?.getCountArchivos) {
            this.$refs.estadoComp.getCountArchivos(this.idSolicitud);
          }
        });
      }
      
  },
  updated(){
    
  },
  methods: {
    fetchSucursales() {
      fetch(process.env.VUE_APP_API_URL + "/admin/sucursales/all", Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);
            return;
          }

          this.departamentos = response.data?.sucursales || [];
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    fetchProductos() {
      const endpoints = ['/productos/all', '/admin/productos/all'];
      this.fetchProductosFromEndpoints(endpoints, 0);
    },
    fetchProductosFromEndpoints(endpoints, index) {
      if (index >= endpoints.length) {
        this.productosReady = true;
        this.productosError = true;
        return;
      }

      const headers = new Headers();
      headers.append('Authorization', 'Bearer ' + store.token);

      fetch(process.env.VUE_APP_API_URL + endpoints[index], { method: 'GET', headers })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.fetchProductosFromEndpoints(endpoints, index + 1);
            return;
          }

          const productos = response.data?.productos || response.data || [];
          this.productos = this.normalizarProductos(productos);
          this.productosReady = true;
          this.productosError = false;
          this.sincronizarProductoSeleccionado(true);
          this.setProductoInicial();
        })
        .catch(() => {
          this.fetchProductosFromEndpoints(endpoints, index + 1);
        });
    },
    normalizarProductos(productos) {
      if (!Array.isArray(productos)) {
        return [];
      }

      return productos
        .filter((producto) => producto && producto.nombre)
        .map((producto) => ({
          ...producto,
          nombre: String(producto.nombre).trim(),
        }))
        .filter((producto) => producto.nombre !== '');
    },
    normalizarProductoConfiguracion(producto) {
      if (!producto || typeof producto !== 'object') {
        return producto;
      }

      return {
        ...producto,
        nombre: String(producto.nombre || '').trim(),
        periodoPago: Array.isArray(producto.periodoPago) ? producto.periodoPago : [],
        comisiones: Array.isArray(producto.comisiones) ? producto.comisiones : [],
      };
    },
    getProductoNombre(producto = this.solicitudCompleta.producto) {
      if (!producto) {
        return '';
      }

      if (typeof producto === 'object') {
        return String(producto.nombre || '').trim();
      }

      return String(producto).trim();
    },
    obtenerComisionesProductoSeleccionado() {
      const productoActual = this.solicitudCompleta.producto || this.solicitud.producto;
      const productoActualNombre = this.getProductoNombre(productoActual);
      const productoActualId = this.solicitud.productoId || (productoActual && typeof productoActual === 'object' ? productoActual.id : null);
      let producto = typeof productoActual === 'object' ? productoActual : null;

      if (!producto) {
        producto = this.productosSeleccionables.find((item) => {
          const mismoId = productoActualId && String(item.id) === String(productoActualId);
          const mismoNombre = productoActualNombre && this.getProductoNombre(item).toLowerCase() === productoActualNombre.toLowerCase();
          return mismoId || mismoNombre;
        });
      }

      let comisiones = [];
      if (Array.isArray(producto?.comisiones)) {
        comisiones = producto.comisiones;
      } else if (typeof producto?.comisiones === 'string') {
        try {
          const comisionesParseadas = JSON.parse(producto.comisiones);
          comisiones = Array.isArray(comisionesParseadas) ? comisionesParseadas : [];
        } catch (error) {
          comisiones = [];
        }
      }

      const comisionesNormalizadas = comisiones
        .map((comision, index) => ({
          key: comision?.id || `${comision?.nombre || 'comision'}-${index}`,
          nombre: String(comision?.nombre || '').trim(),
          porcentaje: Number(comision?.porcentaje),
        }))
        .filter((comision) => comision.nombre && Number.isFinite(comision.porcentaje));

      if (comisionesNormalizadas.length > 0) {
        return comisionesNormalizadas;
      }

      return [
        { key: 'otorgamiento', nombre: 'Comisión por Otorgamiento', porcentaje: Number(this.comisionOtorgamiento) },
        { key: 'asistencia-tecnica', nombre: 'Comisión por Asistencia Técnica', porcentaje: Number(this.comisionAsistenciaTecnica) },
      ].filter((comision) => Number.isFinite(comision.porcentaje) && comision.porcentaje > 0);
    },
    sincronizarProductoSeleccionado(fetchDetalle = false) {
      if (this.idSolicitud > 0 && !this.solicitud.producto) {
        return;
      }

      const productoActual = this.solicitudCompleta.producto || this.solicitud.producto;
      const productoActualId = this.solicitud.productoId || (productoActual && typeof productoActual === 'object' ? productoActual.id : null);
      const productoActualNombre = this.getProductoNombre(productoActual);

      let productoEncontrado = null;
      if (productoActualId) {
        productoEncontrado = this.productosSeleccionables.find(
          (producto) => String(producto.id) === String(productoActualId)
        );
      }

      if (!productoEncontrado && productoActualNombre) {
        productoEncontrado = this.productosSeleccionables.find(
          (producto) => this.getProductoNombre(producto).toLowerCase() === productoActualNombre.toLowerCase()
        );
      }

      if (!productoEncontrado) {
        return;
      }

      this.productoSeleccionadoId = String(productoEncontrado.id);
      if (fetchDetalle && productoEncontrado.id && !String(productoEncontrado.id).startsWith('actual-')) {
        this.fetchProductoSeleccionado(productoEncontrado.id);
      }
    },
    setProductoInicial() {
      if (this.solicitudCompleta.producto) {
        return;
      }
      if (this.idSolicitud > 0) {
        return;
      }

      const primerProducto = this.productosSeleccionables[0];
      if (primerProducto) {
        this.productoSeleccionadoId = String(primerProducto.id);
        this.fetchProductoSeleccionado(primerProducto.id);
      }
    },
    seleccionarProductoPorId() {
      const productoId = this.productoSeleccionadoId;
      if (!productoId) {
        this.solicitudCompleta.producto = "";
        this.productoConfigLoading = false;
        this.productoConfigError = false;
        return;
      }

      if (String(productoId).startsWith('actual-')) {
        const productoActual = this.productosSeleccionables.find(
          (producto) => String(producto.id) === String(productoId)
        );
        if (productoActual) {
          this.solicitudCompleta.producto = this.normalizarProductoConfiguracion(productoActual);
          this.solicitud.producto = this.getProductoNombre(productoActual);
          this.solicitud.productoId = productoActual.id || 0;
        }
        this.productoConfigLoading = false;
        this.productoConfigError = false;
        return;
      }

      this.fetchProductoSeleccionado(productoId);
    },
    fetchProductoSeleccionado(productoId) {
      const endpoints = [`/admin/productos/${productoId}`];
      this.fetchProductoSeleccionadoFromEndpoints(endpoints, 0, productoId);
    },
    fetchProductoSeleccionadoFromEndpoints(endpoints, index, productoId) {
      if (index === 0) {
        this.productoConfigLoading = true;
        this.productoConfigError = false;
      }

      if (index >= endpoints.length) {
        if (String(this.productoSeleccionadoId) !== String(productoId)) {
          return;
        }
        this.productoConfigLoading = false;
        this.productoConfigError = true;
        return;
      }

      const headers = new Headers();
      headers.append('Authorization', 'Bearer ' + store.token);

      fetch(process.env.VUE_APP_API_URL + endpoints[index], { method: 'GET', headers })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.fetchProductoSeleccionadoFromEndpoints(endpoints, index + 1, productoId);
            return;
          }

          const producto = response.data?.producto || response.data;
          if (!producto) {
            this.fetchProductoSeleccionadoFromEndpoints(endpoints, index + 1, productoId);
            return;
          }

          const productoConfiguracion = this.normalizarProductoConfiguracion(producto);
          if (String(this.productoSeleccionadoId) !== String(productoId)) {
            return;
          }
          this.solicitudCompleta.producto = productoConfiguracion;
          this.solicitud.producto = this.getProductoNombre(productoConfiguracion);
          this.solicitud.productoId = productoConfiguracion.id || 0;
          this.productoSeleccionadoId = String(productoConfiguracion.id);
          this.productoConfigLoading = false;
          this.productoConfigError = false;
        })
        .catch(() => {
          this.fetchProductoSeleccionadoFromEndpoints(endpoints, index + 1, productoId);
        });
    },
    obtenerTasaInteresMicro(){

      switch (this.claseScore) {
        case "A":
          this.solicitud.interes = 26;
         
          break;
        case "B":
          this.solicitud.interes = 28;
       
          break;
        case "C":
          this.solicitud.interes = 31;
         
          break;
        case "D":
          this.solicitud.interes = 34;
         
          break;
        case "E":
          this.solicitud.interes = 36;
        
          break;
        default:
          this.solicitud.interes = 36;
          
      }
    },
    guardarFirma(firma) {
      this.firmaBase64 = firma
      console.log('Firma Base64:', firma)
      // Aquí puedes hacer un fetch para guardar en backend si quieres
    },
    mostrarAlerta() {
      alert('La firma está vacía.')
    },
    obtenerCuotaTotal({
  monto,
  frecuenciaPago,
  interesAnual,     // ejemplo: 24 (para 24%)
  plazo,            // tu "plazoPago"
  producto,
  periodoGracia = 0 // numero de cuotas en gracia (según tu lógica actual)
}) {
  const tasaAnual = interesAnual / 100;

  let periodo = 12;
  let diasPeriodo = 30.0;
  let noCuotas = plazo;

  switch (this.limpiarYMinusc(frecuenciaPago)) {
    case "mensual":
      noCuotas = plazo;
      periodo = 12;
      diasPeriodo = 30.0;
      break;

    case "quincenal":
      noCuotas = plazo * 2;
      periodo = 24;
      diasPeriodo = 15.0;
      break;

    case "semanal":
      noCuotas = this.esCrediTrabajo(producto) ? (plazo * 4) : (plazo * 4.3333333333);
      noCuotas = Math.round(noCuotas);
      periodo = 52.1;
      diasPeriodo = 7.0;
      break;

    case "alvencimiento":
      noCuotas = 1;
      periodo = (30 / (plazo * 30)) * 12;
      diasPeriodo = plazo * 30;
      break;

    case "bimensual":
      noCuotas = plazo / 2;
      periodo = 6;
      diasPeriodo = 60.0;
      break;

    case "trimestral":
      noCuotas = plazo / 3;
      periodo = 4;
      diasPeriodo = 90.0;
      break;

    case "semestral":
      noCuotas = plazo / 6;
      periodo = 2;
      diasPeriodo = 180.0;
      break;

    case "anual":
      noCuotas = plazo / 12;
      periodo = 1;
      diasPeriodo = 360.0;
      break;

    default:
      console.log("Periodo de pago no válido");
      return 0;
  }

  // Caso especial: CrediTrabajo / Credi Trabajo 2 => cuota = capital/noCuotas
  const productoNombre = this.getProductoNombre(producto);
  if (this.comprobarCrediTrabajo(producto) === true || productoNombre === "Credi Trabajo 2") {
    noCuotas = Math.round(noCuotas);
    return monto / noCuotas;
  }

  // Cuota nivelada normal (con ajuste por periodo de gracia como en tu código)
  let periodosParaCuota = plazo;
  if (periodoGracia > 0) {
    periodosParaCuota = plazo - (periodoGracia * 12 / periodo);
  }

  return this.CalculaCuotaNivelada(
    monto,
    tasaAnual,
    periodosParaCuota,
    periodo,
    diasPeriodo
  );
},
comprobarCrediTrabajo(producto) {
            const productoNombre = this.getProductoNombre(producto).trim().toLowerCase();
            return productoNombre === 'credi trabajo' || productoNombre === 'creditrabajo';
        },

    generarPagosInteres() {
      // Reinicia el arreglo según la cantidad indicada
      this.pagosInteres = Array.from({ length: this.noPagosAPInteres }, () => ({
        monto: null,
        fecha: ''
      }));
    },
      irASolicitante( cliente) {
        if (cliente != undefined) {
        console.log('Cliente ID:', cliente.id);
        this.store.aprobacion.id = cliente.id;
        this.store.aprobacion.validacion = false;
        this.$router.push(`/solicitante/${cliente.id}`);
      } else {
        console.warn('ID de cliente no disponible');
      }
    },
    dateFormat(param) {
      // const date = new Date(param)

      // const dia = (param)?.slice(8, 10)
      // const mes = date.toLocaleDateString('es-ES', { month: 'long' })
      // const anio = date.getFullYear()
      // const dateFormated = `${dia}/${mes.slice(0, 3)}/${anio}`
      // return dateFormated
      // Fecha en formato ISO 8601
      // Fecha en formato ISO 8601
      var fechaISO = param;


      // Crear un objeto Date con la fecha proporcionada
      var fecha = new Date(fechaISO);

      // Obtener el día del mes (agregando un cero inicial si es necesario)
      var dia = ('0' + fecha.getUTCDate()).slice(-2);

      // Obtener el mes (agregando un cero inicial si es necesario)
      var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);

      // Obtener el año
      var anio = fecha.getUTCFullYear();

      // Formatear la fecha según tus necesidades
      var fechaFormateada = dia + '/' + mes + '/' + anio;

      console.log(fechaFormateada); // Salida: 01/12/2023

      return fechaFormateada;

    },
    convertirISOaFechaCorta(fechaISO) {
      const fecha = new Date(fechaISO);
      const anio = fecha.getUTCFullYear();
      const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
      const dia = String(fecha.getUTCDate()).padStart(2, '0');
      return `${anio}-${mes}-${dia}`;
    },

    creditrabajo2() {
      return this.productoSeleccionadoNombre === 'Credi Trabajo 2'

    },
    creaFuturo() {
      return this.productoSeleccionadoNombre === 'CREAFUTURO'

    },
    microCredito() {
      return this.productoSeleccionadoNombre === 'MICROCREDITO'

    },
    onBlur() {
      //Funcion para calcular el monto del credito



      if (this.montoOtorgar > 0 || this.solicitud.monto > 0) {
        // Crea Futuro
        if (this.creaFuturo()) {
          // this.solicitud.interes = 12
          this.comisionOtorgamiento = 3.5
          this.comisionAsistenciaTecnica = 4.5
          this.tasaSeguridad = 0.2
          this.reservasSeguros = 1.6
          this.consultasBuro = 0.2

          this.totalComisionOtorgamiento = (this.comisionOtorgamiento / 100) * this.solicitud.monto
          this.totalComisionAsistenciaTecnica = (this.comisionAsistenciaTecnica / 100) * this.solicitud.monto

          this.tasaSeguridad = 0.2
          this.totalTasaSeguridad = (0.2 / 100) * this.solicitud.monto
          this.totalReservasSeguros = (this.reservasSeguros / 100) * this.solicitud.monto
          this.totalConsultasBuro = (this.consultasBuro / 100) * this.solicitud.monto
          this.totalComisionOtorgamiento = this.totalComisionOtorgamiento.toFixed(2)
          this.totalComisionAsistenciaTecnica = this.totalComisionAsistenciaTecnica.toFixed(2)

          // const montoOtorgar = parseInt(this.montoOtorgar, 10);
          const totalComisionOtorgamiento = this.totalComisionOtorgamiento;
          const totalTasaSeguridad = this.totalTasaSeguridad;
          const totalComisionAsistenciaTecnica = this.totalComisionAsistenciaTecnica;
          // const cobroPorACH = 40.00;

          if (this.cliente?.nombreBanco === 'Banco de Desarrollo Rural Honduras') {
            this.cobroPorACH = 0.00
          }
          this.solicitud.montoOtorgar = (this.solicitud.monto - totalComisionOtorgamiento - totalTasaSeguridad - totalComisionAsistenciaTecnica - this.cobroPorACH - this.totalReservasSeguros - this.totalConsultasBuro).toFixed(2);
          this.montoOtorgar = this.solicitud.montoOtorgar

        } else if (this.microCredito()) {
          // this.solicitud.interes = 12
          this.comisionOtorgamiento = 6.0
          this.comisionAsistenciaTecnica = 8.0
          this.tasaSeguridad = 0.2
          this.reservasSeguros = 1.6
          this.consultasBuro = 0.2

          this.totalComisionOtorgamiento = (this.comisionOtorgamiento / 100) * this.solicitud.monto
          this.totalComisionAsistenciaTecnica = (this.comisionAsistenciaTecnica / 100) * this.solicitud.monto

          this.tasaSeguridad = 0.2
          this.totalTasaSeguridad = (0.2 / 100) * this.solicitud.monto
          this.totalReservasSeguros = (this.reservasSeguros / 100) * this.solicitud.monto
          this.totalConsultasBuro = (this.consultasBuro / 100) * this.solicitud.monto
          this.totalComisionOtorgamiento = this.totalComisionOtorgamiento.toFixed(2)
          this.totalComisionAsistenciaTecnica = this.totalComisionAsistenciaTecnica.toFixed(2)

          // const montoOtorgar = parseInt(this.montoOtorgar, 10);
          const totalComisionOtorgamiento = this.totalComisionOtorgamiento;
          const totalTasaSeguridad = this.totalTasaSeguridad;
          const totalComisionAsistenciaTecnica = this.totalComisionAsistenciaTecnica;
          // const cobroPorACH = 40.00;

          if (this.cliente?.nombreBanco === 'Banco de Desarrollo Rural Honduras') {
            this.cobroPorACH = 0.00
          }
          this.solicitud.montoOtorgar = (this.solicitud.monto - totalComisionOtorgamiento - totalTasaSeguridad - totalComisionAsistenciaTecnica - this.cobroPorACH - this.totalReservasSeguros - this.totalConsultasBuro).toFixed(2);
          this.montoOtorgar = this.solicitud.montoOtorgar

        } else {
          if (this.solicitud.plazoPago > 0 && this.solicitud.plazoPago < 7 && this.creditrabajo2()) {
            console.log("Entra en Creditrabajo 2 Pago");
            
            this.totalComisionOtorgamiento = (4.5 / 100) * this.montoOtorgar
            this.totalComisionAsistenciaTecnica = (4.0 / 100) * this.montoOtorgar

            this.totalTasaSeguridad = (0.4 / 100) * this.montoOtorgar

            this.montoInteres = (((this.montoOtorgar * (5 / 100)) * this.solicitud.plazoPago) - (this.totalComisionAsistenciaTecnica + this.totalComisionOtorgamiento))
            // this.solicitud.monto = this.montoOtorgar + this.montoInteres
            this.totalComisionOtorgamiento = parseInt(this.totalComisionOtorgamiento, 10).toFixed(2)
            this.totalComisionAsistenciaTecnica = parseInt(this.totalComisionAsistenciaTecnica, 10).toFixed(2)
            // Convertir los valores a enteros antes de sumarlos
            const montoOtorgar = parseInt(this.montoOtorgar, 10);
            const montoInteres = parseInt(this.montoInteres, 10);
            const totalComisionOtorgamiento = parseInt(this.totalComisionOtorgamiento, 10);
            const totalTasaSeguridad = parseInt(this.totalTasaSeguridad, 10);
            const totalComisionAsistenciaTecnica = parseInt(this.totalComisionAsistenciaTecnica, 10);

            // Asignar la suma a solicitud.monto
            this.solicitud.monto = (montoOtorgar + montoInteres + totalComisionOtorgamiento + totalTasaSeguridad + totalComisionAsistenciaTecnica).toFixed(2);

            console.log("El campo de interés perdió el foco. Valor actual: " + this.totalComisionOtorgamiento);

          }
        }
      }


      // Lógica adicional que deseas ejecutar cuando se sale del input
    },
    async exportarSolicitudPDF(tipoExportar) {
      const doc = new jsPDF()
      var tableHeight

      // Calcula las dimensiones del documento
      const docWidth = doc.internal.pageSize.getWidth();
      const pageMargin = 12;
      const pageContentWidth = docWidth - (pageMargin * 2);
      const primaryColor = [18, 45, 78];
      const accentColor = [31, 111, 139];
      const softFill = [246, 249, 252];
      const lineColor = [218, 226, 235];
      const textColor = [32, 42, 54];
      const sectionTitle = (title, yPosition) => {
        doc.setFillColor(...primaryColor);
        doc.roundedRect(pageMargin, yPosition, pageContentWidth, 8, 2, 2, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
        doc.setTextColor(255, 255, 255);
        doc.text(title, pageMargin + 4, yPosition + 5.4);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(...textColor);
        return yPosition + 10;
      };
      const tableOptions = {
        theme: 'plain',
        margin: { left: pageMargin, right: pageMargin },
        styles: {
          fontSize: 8,
          cellPadding: { top: 2.4, right: 2.6, bottom: 2.4, left: 2.6 },
          halign: 'left',
          valign: 'middle',
          textColor,
          lineColor,
          lineWidth: 0.08,
        },
        alternateRowStyles: {
          fillColor: softFill,
        },
      };
      // Agrega una imagen al documento
      const img = new Image();
      img.src = require('@/assets/header.png'); // Reemplaza 'mi_imagen.jpg' con el nombre de tu imagen
      // Calcula las dimensiones de la imagen para que ocupe todo el ancho de la página
      const imgWidth = docWidth;
      // const imgHeight = (img.height * imgWidth) / img.width;
      // doc.addImage(img, 'PNG', 10, 10, 300, 200); // Ajusta las coordenadas y el tamaño según tu necesidad
      doc.addImage(img, 'PNG', 0, 0, imgWidth, 30);
      doc.setTextColor(...textColor);

      const product = 'Producto: ' + ((this.solicitud.producto == 'Credi Trabajo 2' ? 'Creditrabajo' : this.solicitud.producto))
      const date = 'Fecha ' + new Date().toLocaleDateString('en-GB')

      doc.setFillColor(255, 255, 255);
      doc.roundedRect(pageMargin, 33, pageContentWidth, 12, 2, 2, 'F');
      doc.setDrawColor(...lineColor);
      doc.roundedRect(pageMargin, 33, pageContentWidth, 12, 2, 2, 'S');
      doc.setFontSize(9)
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...accentColor);
      doc.text(product, pageMargin + 4, 40, { align: 'left' });
      doc.text(date, doc.internal.pageSize.width - pageMargin - 4, 40, { align: 'right' });
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...textColor);
      tableHeight = sectionTitle('DATOS PERSONALES DEL SOLICITANTE', 50)
      doc.autoTable({
        body: [
          [{ content: `Nombre Completo: ${this.cliente?.nombres ? this.cliente?.nombres : '-'} ${this.cliente?.apellidos ? this.cliente?.apellidos : ''}`, colSpan: 12, styles: { fontStyle: 'bold', fontSize: 9, fillColor: [235, 243, 247], textColor: primaryColor } }],
          [{ content: `Número de Identidad: ${this.cliente?.dni ? this.cliente?.dni : ''}`, colSpan: 6 }, { content: `Lugar de Nacimiento: ${this.cliente?.lugarNacimiento ? this.cliente?.lugarNacimiento : ''}`, colSpan: 3 }, { content: `Sexo: ${this.cliente?.sexo ? this.cliente?.sexo : ''}`, colSpan: 3 }],

          [{ content: `Estado Civil: ${this.cliente?.estadoCivil ? this.cliente?.estadoCivil : '-'}`, colSpan: 5 }, { content: `Fecha de Nacimiento: ${this.cliente?.fechaNacimiento ? this.cliente?.fechaNacimiento : '-'}`, colSpan: 4 }, { content: `Edad: ${this.cliente.edad ? this.cliente.edad : '-'}`, colSpan: 3 }],
          [{ content: `Correo Electronico: ${this.cliente?.email ? this.cliente?.email : '-'}`, colSpan: 6 }, { content: `Telefono: ${this.cliente.telefono ? this.cliente.telefono : ''}`, colSpan: 3 }, { content: `Celular: ${this.cliente?.celular ? this.cliente?.celular : "-"}`, colSpan: 3 }]
        ],
        startY: tableHeight,
        ...tableOptions,
        didDrawPage: function (data) {
          // Guardar la altura de la tabla
          tableHeight = data.cursor.y;
        }
      })


      tableHeight += 8
      tableHeight = sectionTitle('DATOS DOMICILIARES DEL SOLICITANTE', tableHeight)
      doc.autoTable({
        body: [
          [
            { content: `Depto.: ${this.cliente?.departamento ? this.cliente.departamento : '-'}`, colSpan: 4 },
            { content: `Municipio: ${this.cliente?.municipio ? this.cliente.municipio : '-'}`, colSpan: 4 },
            { content: `Col/ Bar/ Ald: ${this.cliente?.colonia ? this.cliente.colonia : '-'}`, colSpan: 4 },
            { content: `Calle: ${this.cliente?.calle ? this.cliente.calle : '-'}`, colSpan: 2 },
            { content: `Avenida: ${this.cliente?.avenida ? this.cliente.avenida : '-'}`, colSpan: 2 },
            { content: `Bloque: ${this.cliente?.bloque ? this.cliente.bloque : '-'}`, colSpan: 2 },
            { content: `Casa No. ${this.cliente?.noCasa ? this.cliente.noCasa : '-'}`, colSpan: 2 },
          ],
          [
            { content: `Punto de Referencia: ${this.cliente.puntoReferencia ? this.cliente.puntoReferencia : '-'}`, colSpan: 12 },
            { content: `Tipo de vivienda: ${this.cliente.tipoVivienda ? this.cliente.tipoVivienda : '-'}`, colSpan: 4 },
            { content: `Cuota de Vivienda: ${this.cliente?.cuotaVivienda ? this.cliente.cuotaVivienda : '-'}`, colSpan: 4 },
          ],
          [
            { content: `Si Alquila (Nombre y Telefono del propietario): ${this.cliente?.propietarioAlquila ? this.cliente?.propietarioAlquila : '-'}`, colSpan: 20 },
          ],
        ],
        startY: tableHeight,
        ...tableOptions,
        didDrawPage: function (data) {
          // Guardar la altura de la tabla
          tableHeight = data.cursor.y;
        }
      });

      if (this.cliente.nombresConyugue != undefined) {
        tableHeight += 8
        tableHeight = sectionTitle('DATOS CONYUGUE', tableHeight)
        doc.autoTable({
          body: [
            [
              { content: `Nombre Completo: ${this.cliente.nombresConyugue ? this.cliente.nombresConyugue : ''} ${this.cliente.apellidosConyugue ? this.cliente.apellidosConyugue : ''}`, colSpan: 5 },
              { content: `Número de Identidad: ${this.cliente.dniConyugue ? this.cliente.dniConyugue : '-'} `, colSpan: 5 },
            ],
            [
              { content: `Correo ELectrónico: ${this.cliente.emailConyugue ? this.cliente.emailConyugue : '-'}`, colSpan: 5 },
              { content: `Celular: ${this.cliente.celularConyugue ? this.cliente.celularConyugue : '-'}`, colSpan: 5 },
            ],
          ],
          startY: tableHeight,
          ...tableOptions,
          didDrawPage: function (data) {
            // Guardar la altura de la tabla
            tableHeight = data.cursor.y;
          }

        })
        doc.addPage()
        tableHeight = 20

      } else {

        tableHeight += 10
      }
      doc.setFontSize(10)
      doc.text('1. Certifico que la información arriba descrita es verídica y autorizo para que sea confirmada si así fuera el caso \ncualquier dato falso sea motivo para la no aprobación del préstamo.', 15, tableHeight)
      tableHeight += 20

      doc.text('_____________________________________', 65, 195);
      doc.autoTable({
        body: [
          [
            { content: '(f) Solicitante (Firma o Huella)', colSpan: 6 },
          ],
          [
            { content: 'Nosotros los abajo firmantes damos fé de haber validado en campo la información brindada por el solicitante, el cual es verídica.', colSpan: 6 },
          ]
        ],
        startY: 197,
        theme: 'plain',
        styles: {
          halign: 'center',
        },
      })

      if(tipoExportar === 'FIRMA'){
  // Coordenadas donde debe firmar el asesor:
        doc.setFontSize(30)

doc.text('{{FirmaAsesor_es_:signer1:signature}}', 35, 225);
// Fecha de firma:
doc.setFontSize(11)
doc.text('{{FechaAsesor_es_:signer1:date}}', 29, 243);
    }
      

      doc.text('_________________________________', 25, 230);
      doc.text('_________________________________', 115, 230);
      doc.autoTable({
        body: [
          [
            { content: 'Oficial de Microcrédito', colSpan: 6 },
            { content: 'Jefe Departamental', colSpan: 6 },
          ]
        ],
        startY: 232,
        theme: 'plain',
        styles: {
          halign: 'center',
        },
      })

      doc.autoTable({
        body: [
          [
            { content: 'CONDICIONES DEL CRÉDITO', colSpan: 3, styles: { fillColor: primaryColor, textColor: [255, 255, 255], fontStyle: 'bold', halign: 'center', fontSize: 9 } },
          ],
          [
            { content: `Monto\n${this.solicitud.monto ? this.solicitud.monto : '-'}`, styles: { fillColor: [235, 243, 247], fontStyle: 'bold', halign: 'center' } },
            { content: `Plazo de Pago\n${this.solicitud.plazoPago ? this.solicitud.plazoPago : '-'}`, styles: { fillColor: [246, 249, 252], fontStyle: 'bold', halign: 'center' } },
            { content: `Frecuencia de Pago\n${this.solicitud.frecuenciaPago ? this.solicitud.frecuenciaPago : '-'}`, styles: { fillColor: [235, 243, 247], fontStyle: 'bold', halign: 'center' } }
          ]
        ],
        startY: 252,
        theme: 'plain',
        styles: {
          fontSize: 8,
          cellPadding: { top: 2.4, right: 3, bottom: 2.4, left: 3 },
          textColor,
          lineColor,
          lineWidth: 0.08,
          valign: 'middle',
        },
      })





  //   if (tipoExportar === 'FIRMA') {
  //     // 1) Genera el PDF como Blob
  //       const blob = doc.output('blob'); // <- en lugar de save()

  //       // 2) Enviar al backend
  //       const form = new FormData();
  //       form.append('file', blob, 'Solicitud.pdf');
  //       form.append('signer_email', "andres15mol@gmail.com"); // correo del asesor
  //       form.append('sender_email', "andres15mol@gmail.com"); 
  //       form.append('name', `Solicitud ${this.solicitud?.codigo || ''}`);
        
  //       const headers = new Headers();
  //       headers.append("Authorization", "Bearer " + this.store.token);
        
  //       const res = await fetch(`${process.env.VUE_APP_API_URL}/admin/init-sign-process`, { method: 'POST', body: form, headers: headers });
  //       const { signing_url } = await res.json();

  // console.log(signing_url);
  //       // 3) Mostrar la firma embebida (iframe o nueva pestaña)
  //       window.open(signing_url, '_blank'); // o bien: <iframe :src="signing_url">

  //   }else{
  //     doc.save('Solicitud.pdf')

  //   }
if (tipoExportar === 'FIRMA') {
  // 1) Genera el PDF como Blob
  const blob = doc.output('blob'); // application/pdf

  // 2) Arma el form-data (NO pongas Content-Type)
  const form = new FormData();
  form.append('file', blob, 'Solicitud.pdf');
  form.append('signer_email', "andres15mol@gmai.com");                // quien firma
  form.append('sender_email', "andres15mol@gmai.com");                // remitente (en DEV: mismo del Integration Key)
  form.append('name', `Solicitud ${this.solicitud?.codigo || ''}`);

  // 3) Enviar al backend
  const res = await fetch(`${process.env.VUE_APP_API_URL}/admin/init-sign-process`, {
    method: 'POST',
    body: form,
    headers: {
      Authorization: `Bearer ${this.store.token}` // si tu backend lo requiere
    },
    // credentials: 'include', // usa esto si tu backend autentica con cookie/sesión
  });

  if (!res.ok) {
    // imprime el texto de error del backend para depurar
    const errText = await res.text();
    console.error('InitSignProcess error:', errText);
    this.$toast?.error?.('No se pudo iniciar la firma');
    return;
  }

  const { signing_url } = await res.json();
  if (!signing_url) {
    console.error('Respuesta sin signing_url');
    this.$toast?.error?.('No se obtuvo el enlace de firma');
    return;
  }

  // 4) Abrir la firma (embebida o pestaña nueva)
  window.open(signing_url, '_blank'); // o <iframe :src="signing_url">
} else {
  doc.save('Solicitud.pdf');
}


    }
    ,
      // =========================
  // HELPERS (como la 2da función)
  // =========================
    //Convertir string a minuscula y sin espacios
    limpiarYMinusc(string) {
      // Eliminar espacios en blanco y convertir a minúsculas
      return string.replace(/\s/g, '').toLowerCase();
    },
    //Convertir numero negativo a 0
    convertirANoNegativo(numero) {
      // Si el número es negativo, convertirlo a cero
      if (numero < 0) {
        return 0;
      } else {
        return numero;
      }
    },

    generarPlanPago(
      fechaApertura,
      monto,
      periodoPago,
      interesAnual,
      plazo,
      pagosInteres,
    ) {

      this.sumaTotalesCero();

      console.log(fechaApertura)
      let fechaInicial = fechaApertura
      // Calcular la tasa de interés mensual
      let tasaAnual = interesAnual / 100;

      // Calcular el intervalo de tiempo entre pagos
      let duracionPago, periodo, noCuotas, interes, diasPeriodo, capital, saldo;

      // Imprimir la cabecera de la tabla

      // Generar el plan de pago
      saldo = monto;


      switch (this.limpiarYMinusc(periodoPago)) {
        case "mensual":
          duracionPago = 30 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 30 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo;
          periodo = 12;
          diasPeriodo = 30.0;
          break;

        case "quincenal":
          duracionPago = 14 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 15 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo * 2;
          periodo = 24;
          diasPeriodo = 15.0;
          break;

        case "semanal":

          duracionPago = 7 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 7 * 24 * 60 * 60 * 1000
          );

          if (this.esCrediTrabajo(this.solicitudCompleta.producto)) {
            noCuotas = plazo * 4;
          } else {
            noCuotas = plazo * (4.3333333333);
          }

          periodo = 52.1;
          diasPeriodo = 7.0;
          break;

        case "alvencimiento":
          duracionPago = 1;
          fechaApertura = new Date(
            fechaApertura.getTime() + (plazo * 30) * 24 * 60 * 60 * 1000
          );
          noCuotas = 1;
          periodo = (30 / (plazo * 30)) * 12;
          diasPeriodo = plazo * 30;
          break;
        case "trimestral":
          duracionPago = 90 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 90 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo / 3;
          periodo = 4;
          diasPeriodo = 90.0;
          break;
        case "semestral":
          duracionPago = 180 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 180 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo / 6;
          periodo = 2;
          diasPeriodo = 180.0;
          break;
        case "anual":
          duracionPago = 360 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 360 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo / 12;
          periodo = 1;
          diasPeriodo = 360.0;
          break;



        default:
          return;
      }

      // Generar el plan de pago
      let cuotaTotal

      if (this.creaFuturo() && this.limpiarYMinusc(periodoPago) !== "semanal") {
        cuotaTotal = this.CalcularCuotaInteresCompuesto(
          monto,
          tasaAnual,
          Math.round(noCuotas),
          periodo,
          diasPeriodo
        );
      } else {
        cuotaTotal = this.CalculaCuotaNivelada(
          monto,
          tasaAnual,
          plazo,
          periodo,
          diasPeriodo
        );
      }
      this.planPagoToPrint = []
      const tablaBody = document.getElementById('tablaPlanPagos')
      tablaBody.innerHTML = ''
      tablaBody.innerHTML = `
        <tr>
          <th class="text-center align-middle" scope="row">0</td>
          <td class="text-center align-middle">${this.dateFormat(fechaInicial.toISOString().slice(0, 10))}</td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle">${this.formatoNumero(saldo)} ${this.moneda}</td>
        </tr>
      `
      this.planPagoToPrint.push({
        noCuota: 0,
        fechaPago: this.dateFormat(fechaInicial.toISOString().slice(0, 10)),
        cuotaTotal: '',
        interes: '',
        capital: '',
        saldo: saldo.toFixed(2) + " " + this.moneda
      })
      
      const productoNombrePlan = this.productoSeleccionadoNombre;
      if (productoNombrePlan !== 'Credi Trabajo' && productoNombrePlan !== 'Credi Trabajo 2') {
        this.cuotaSolicitud = cuotaTotal
        console.log("La Cuota es: ", this.cuotaSolicitud);

        console.log(diasPeriodo, "Dias del periodo");

        let contador = 0
        for (let i = 1; i <= Math.round(noCuotas); i++) {



          if (this.creaFuturo() && this.limpiarYMinusc(periodoPago) !== "semanal") {
            interes = saldo * (tasaAnual / 12)
          } else {
            interes = ((saldo * tasaAnual) / 360) * diasPeriodo;
          }
          capital = cuotaTotal - interes;
          saldo = saldo - capital;
          saldo = this.convertirANoNegativo(saldo)
          // Imprimir la fila de la tabla
          tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(fechaApertura.toISOString().slice(0, 10))}</td>
            <td class="text-center align-middle">${Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(interes).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            </tr>
          `


          // console.log("Pagos de Interes O.o", pagosInteres[i]);
          // console.log("Pagos de Interes O.o", this.buscarPagosEntreFechas(pagosInteres, fechaApertura, new Date(fechaApertura.getTime() + duracionPago)));

          if (contador < this.pagosInteres.length) {

            if (new Date(this.pagosInteres[contador].fecha) >= fechaApertura && new Date(this.pagosInteres[contador].fecha) <= new Date(fechaApertura.getTime() + duracionPago)) {
              console.log("Pagos de Interes O.o", this.pagosInteres[contador]);

              tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(pagosInteres[contador].fecha)}</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle">${Number(pagosInteres[contador].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle"></td>
            </tr>
          `
              contador++

            }
          }

          console.log("fecha plan Pago: ", fechaApertura);
          console.log("fecha plan Pago proxima: ", new Date(fechaApertura.getTime() + duracionPago));


          this.planPagoToPrint.push({
            noCuota: i,
            fechaPago: this.dateFormat(fechaApertura.toISOString().slice(0, 10)),
            cuotaTotal: Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            interes: Number(interes).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            capital: Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda
          })
          this.fechaVencimiento = fechaApertura
          fechaApertura = new Date(fechaApertura.getTime() + duracionPago);



        }
      } else {
        //Creditrabajo
        if (this.creditrabajo2) {
          noCuotas = Math.round(noCuotas)
        }

        console.log("El numero de Cuotas es: ", noCuotas);
        cuotaTotal = monto / noCuotas;
        this.cuotaSolicitud = cuotaTotal
        console.log("La Cuota es: ", this.cuotaSolicitud);
        for (let i = 1; i <= Math.round(noCuotas); i++) {
          interes = ((saldo * tasaAnual) / 360) * diasPeriodo;
          capital = cuotaTotal;
          saldo = this.convertirANoNegativo(saldo - capital);
          // Imprimir la fila de la tabla
          tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(fechaApertura.toISOString().slice(0, 10))}</td>
            <td class="text-center align-middle">${cuotaTotal.toFixed(2)} ${this.moneda}</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle">${capital.toFixed(2)} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            </tr>
            `
          this.planPagoToPrint.push({
            noCuota: i,
            fechaPago: this.dateFormat(fechaApertura.toISOString().slice(0, 10)),
            cuotaTotal: Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            interes: '',
            capital: Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda
          })
          this.fechaVencimiento = fechaApertura
          fechaApertura = new Date(fechaApertura.getTime() + duracionPago);


          this.SumaCuotaTotal += cuotaTotal
          this.SumaInteres += interes
          this.SumaCapital += capital
          this.SumaSaldo += saldo
        }
      }

      tablaBody.innerHTML += `
          <tr class="table-success">
            <th class="text-center align-middle" scope="row"></th>
            <td class="text-center align-middle"> <strong> Total </strong></td>
            <td class="text-center align-middle"><strong>${Number(this.SumaCuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</strong></td>
            <td class="text-center align-middle"><strong>${Number(this.SumaInteres).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</strong></td>
            <td class="text-center align-middle"><strong>${Number(this.SumaCapital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</strong></td>
            <td class="text-center align-middle"><strong></strong></td>
            </tr>
          `

      this.planPagoToPrint.push({
        noCuota: 0,
        fechaPago: this.dateFormat(fechaApertura.toISOString().slice(0, 10)),
        cuotaTotal: Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
        interes: Number(interes).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
        capital: Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
        saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda
      })
    }
    ,
    esCrediTrabajo(producto) {
      // Convertir producto a minúsculas para normalizar
      producto = this.getProductoNombre(producto).trim().toLowerCase();

      // Lista de valores normalizados
      const creditrabajo = [
        "creditrabajo",
        "credi trabajo",
        "credi trabajo ",
        "credi trabajo",
        "Credi Trabajo",
        "creditrabajo ",
        "creditrabajo ",
        "credi trabajo",
        "creditrabajo",
      ];

      // Verificar si el producto está en la lista de valores normalizados
      return creditrabajo.includes(producto);
    },
    sumaTotalesCero() {
      this.SumaCuotaTotal = 0
      this.SumaInteres = 0
      this.SumaCapital = 0
      this.SumaSaldo = 0
    },

    // CalculaCuotaNivelada calcula la cuota nivelada de un préstamo
    CalculaCuotaNivelada(
      montoPrestamo,
      tasaInteres,
      periodos,
      periodo,
      diasPeriodo
    ) {
      if (periodo === 24) {
        periodos *= 2;
      } else if (periodo === 52.1) {
        periodos *= 4.33;
        periodos = Math.round(periodos);
      } else if (periodo === (30 / (periodos * 30)) * 12) {
        periodos = 1
      } else if (periodo === 4) {
        periodos /= 3;
        // periodos = Math.round(periodos);
      } else if (periodo === 2) {
        periodos /= 6;
        // periodos = Math.round(periodos);
      } else if (periodo === 1) {
        periodos /= 12;
        // periodos = Math.round(periodos);
      }

      let tasaMensual = (tasaInteres / 360) * diasPeriodo;
      tasaMensual = Math.round(tasaMensual * 10000000000) / 10000000000;

      let cuota =
        (montoPrestamo * tasaMensual) / (1 - Math.pow(1 + tasaMensual, -periodos));
      return cuota;
    },
    // CalculaCuotaNivelada calcula la cuota nivelada de un préstamo
    CalcularCuotaInteresCompuesto(
      montoPrestamo,
      tasaInteres,
      periodos,
      periodo,
      diasPeriodo
    ) {

      console.log("periodos: ", periodos, "periodo: ", periodo, " diasPeriod: ", diasPeriodo);
      console.log("montoPrestamo: ", montoPrestamo, "tasaInteres: ", tasaInteres);
      let cuota = (montoPrestamo * tasaInteres / 12) / (1 - Math.pow(1 + tasaInteres / 12, -periodos));
      return cuota;
    },

    stringToDate(dateString) {
      // Cadena con formato mm/dd/yyyy
      // Diseño que coincide con el formato de la cadena
      let date = new Date(dateString.split("/").reverse().join("-"));
      return date;
    },

    crearReferencia(referencia = {}) {
      return {
        id: referencia.id || 0,
        idSolicitud: referencia.idSolicitud || this.solicitud?.id || this.idSolicitud || 0,
        tipoReferencia: referencia.tipoReferencia || "",
        nombreCompleto: referencia.nombreCompleto || "",
        parentescoORelacion: referencia.parentescoORelacion || "",
        direccion: referencia.direccion || "",
        telefono: referencia.telefono || "",
      };
    },

    obtenerOpcionesParentesco(tipoReferencia) {
      const opcionesFamiliares = [
        "Padre",
        "Madre",
        "Hermano(a)",
        "Tío(a)",
        "Abuelo(a)",
        "Sobrino(a)",
        "Hijo(a)",
        "Primo(a)",
        "Suegro(a)",
        "Cuñado(a)",
        "Nuera",
        "Yerno",
        "Esposo(a)",
        "Nieto(a)",
      ];

      const opcionesPersonales = [
        "Amigo(a)",
        "Compañero de Trabajo",
        "Conocido(a)",
      ];

      if (tipoReferencia === "Familiar") {
        return opcionesFamiliares;
      }

      if (tipoReferencia === "Personal") {
        return opcionesPersonales;
      }

      return [];
    },

    prepararReferenciasParaFormulario(referencias) {
      if (!Array.isArray(referencias) || referencias.length === 0) {
        return [this.crearReferencia()];
      }

      return referencias.map((referencia) => this.crearReferencia(referencia));
    },

    referenciaTieneDatos(referencia) {
      return [
        referencia?.tipoReferencia,
        referencia?.nombreCompleto,
        referencia?.parentescoORelacion,
        referencia?.direccion,
        referencia?.telefono,
      ].some((valor) => String(valor || "").trim() !== "");
    },

    normalizarReferencias(referencias) {
      if (!Array.isArray(referencias)) {
        return [];
      }

      return referencias
        .filter((referencia) => this.referenciaTieneDatos(referencia))
        .map((referencia) => ({
          id: referencia.id || 0,
          idSolicitud: Number(referencia.idSolicitud || this.solicitud?.id || this.idSolicitud || 0),
          tipoReferencia: String(referencia.tipoReferencia || "").trim(),
          nombreCompleto: String(referencia.nombreCompleto || "").trim(),
          parentescoORelacion: String(referencia.parentescoORelacion || "").trim(),
          direccion: String(referencia.direccion || "").trim(),
          telefono: String(referencia.telefono || "").trim(),
        }));
    },

    agregarReferencia() {
      if (!Array.isArray(this.solicitud.referencias)) {
        this.solicitud.referencias = [];
      }

      this.solicitud.referencias.push(this.crearReferencia());
    },

    eliminarReferencia(index) {
      if (!Array.isArray(this.solicitud.referencias)) {
        this.solicitud.referencias = [this.crearReferencia()];
        return;
      }

      this.solicitud.referencias.splice(index, 1);

      if (this.solicitud.referencias.length === 0) {
        this.solicitud.referencias.push(this.crearReferencia());
      }
    },

    //Enviar Datos
    submitHandler() {
      //

      if(!this.store.aprobacion.validacion ){
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Debe aprobar la validación de datos antes de continuar.',
        });
        return;
      }

      if(!this.validarPagosInteres && this.arregloPagoIntereses){
        
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Debe agregar al menos un pago de interés.',
          });
          return;
        
      }

      if (!this.montoAprobadoValido) {
        Swal.fire({
          icon: 'error',
          title: 'Monto aprobado fuera de rango',
          text: 'El monto aprobado debe estar dentro del rango configurado para el producto.',
        });
        return;
      }

      if (!this.interesAnualValido) {
        Swal.fire({
          icon: 'error',
          title: 'Interes anual fuera de rango',
          text: 'El interes anual debe estar dentro del rango configurado para el producto.',
        });
        return;
      }

      if (!this.tasaMoraValida) {
        Swal.fire({
          icon: 'error',
          title: 'Tasa moratoria fuera de rango',
          text: 'La tasa moratoria debe estar dentro del rango configurado para el producto.',
        });
        return;
      }

      if (!this.plazoPagoValido) {
        Swal.fire({
          icon: 'error',
          title: 'Plazo fuera de rango',
          text: 'El plazo debe estar dentro del rango configurado para el producto.',
        });
        return;
      }

      this.solicitudCompleta.integranteSolicitud++;

      this.solicitud.montoOtorgar = parseFloat(this.montoOtorgar)

      if (this.solicitudCompleta.solicitudesObject.length >= this.solicitudCompleta.integranteSolicitud)  {
        //Se aumenta el no de integrante que se encuentra por segunda vez

        this.solicitud = this.restaurarSolicitud()
        this.cliente = this.solicitudCompleta.integrantes[this.solicitudCompleta.integranteSolicitud];

      } else {

        //Se aumenta el no de integrante que se encuentra por segunda vez
        // this.solicitudCompleta.integranteSolicitud++;
        //Agregamos El producto a la solicitud
        this.solicitud.producto = this.productoSeleccionadoNombre
        this.solicitud.productoId = parseInt(this.productoSeleccionadoId, 10) || 0
        //Agregamos el Id del cliente a la solicitud
        this.solicitud.clienteId = this.cliente.id;
        //Convertimos en Enteros y en Float
        this.solicitud.plazoPago = parseFloat(this.solicitud.plazoPago, 10)
        this.solicitud.monto = parseFloat(this.solicitud.monto, 10)

        // this.solicitud.interes = parseInt(this.solicitud.interes, 10)

        this.solicitud.periodoGracia = parseFloat(this.solicitud.periodoGracia, 10)

        for (let i = 0; i < this.pagosInteres.length; i++) {
          this.pagosInteres[i].fecha = this.convertirFechaAISO(this.pagosInteres[i].fecha);
          if (this.solicitud.id > 0) {
            this.pagosInteres[i].solicitudId = this.solicitud.id;
          }
        }
        this.solicitud.pagosInteres = this.pagosInteres
        this.solicitud.referencias = this.normalizarReferencias(this.solicitud.referencias)

        this.solicitud.coordinador = this.solicitudCompleta.coordinador

        //Agrego solicitud a Payload y la solicitud a solicitudes
        let payload = this.solicitud;
        this.solicitudCompleta.solicitudesObject.push(this.solicitud)
        payload = {
          ...payload,
          idUsuario: Security.getUser()[0].user.id,
        }

        ////////////////////////////
        //Si el integrante por el que va es igual total de integrantes del grupo solidario
        if (
          (this.solicitudCompleta.integranteSolicitud ===
          this.solicitudCompleta.integrantes.length ) 
        ) {
          this.solicitudCompleta.integranteSolicitud--;

          console.log("Datos que se envian", payload);

          Swal.fire({
            title: '¿Estás Seguro de que deseas agregar la solicitud?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, Creala!'
          }).then((result) => {
            if (result.isConfirmed) {

              //Agregar Solicitudes
              this.solicitudCompleta.integranteSolicitud = 0;

              console.log("Tasa Mora ", this.tasaMora);
              fetch(`${process.env.VUE_APP_API_URL}/admin/solicitudes/save`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((data) => {
                  if (data.error) {
                    this.$emit('error', data.message)
                    Swal.fire({
                      // position: 'top-end',
                      icon: "error",
                      title: data.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  } else {
                    //Agregar id de solicitud
                    solicitudCompleta.solicitudes.push(data.data.id)
                    //Info Correcta
                    Swal.fire({
                      // position: 'top-end',
                      icon: "success",
                      title: "Se ha Guardado Correctamente la Solicitud",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.solicitudCompleta.integrantes = []
                    this.solicitudCompleta.producto = ""
                    this.productoSeleccionadoId = ""
                    this.solicitudCompleta.integranteSolicitud = 0
                    this.solicitudCompleta.solicitudes = []
                    this.solicitudCompleta.solicitudesObject = []
                    Swal.fire({
                      // position: 'top-end',
                      icon: "success",
                      title: "Se ha terminado de crear solicitud",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    //Reestablecer Página
                    window.onbeforeunload = null; // Desactiva la confirmación de navegación
                    this.final = true;
                    // router.push("/solicitud");
                    // location.reload();
                    // window.location.href = "/solicitud";


                    if(data.data.id){
                      router.push("/archivos/"+data.data.id);
                    }else{
                      location.reload()
                    }

                  }
                })
                .catch((error) => {
                  this.$emit('error', error);
                })






            }
          })

          /////////////////////////////////////
          //Else Caso contrario que el numero no sea igual al total de intergrantes
        } else {

          //Se guardan los datos del integrate por el que va segun el index que es integranteSolicitud
          this.cliente = this.solicitudCompleta.integrantes[this.solicitudCompleta.integranteSolicitud];
                  console.log("Datos que se envian", payload);

          //Peticion Fetch
          Swal.fire({
            title: '¿Estás Seguro de que deseas modificar la solicitud?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Guardar Cambios!'
          }).then((result) => {
            if (result.isConfirmed) {
              fetch(`${process.env.VUE_APP_API_URL}/admin/solicitudes/save`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((data) => {
                  if (data.error) {
                    //Mensaje Alerta Error
                    Swal.fire({
                      icon: "error",
                      title: data.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });

                  } else {

                    // //Agregar id de solicitud
                    // solicitudCompleta.solicitudes.push(data.data.id)

                    //Alerta de que guardo correctamente
                    Swal.fire({
                      icon: "success",
                      title: "Se ha Guardado Correctamente la Solicitud",
                      showConfirmButton: false,
                      timer: 1500,
                    });

                    console.log(data.data.id, "ID DE LA SOLICITUD");
                    if(data.data.id){
                      router.push("/archivos/"+data.data.id);
                    }else{
                      location.reload()
                    }
               

                  }
                })
                .catch((error) => {
                  this.$emit('error', error);
                })

              //Se usa funcion que no quita la validación de Seguridad que se perderan los datos  
              this.quitarValidacion()

              // this.solicitud = this.restaurarSolicitud()
              //Se resetea el Formulario
              document.getElementById("cliente-form").reset();

              // if (this.solicitudCompleta.producto !== "Escalonado") {
              //   router.push("/solicitud");

              // }

            } 

            
          })
        }
      }
    },
    FotoBenficiario(dni){
      let payload = {
        dni: dni,
        id: this.$route.params.solicitudId,
      }
      //editing a solicitante
      fetch(
        process.env.VUE_APP_API_URL +
        "/admin/foto-clientes" ,
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit("error", data.message);
          } else {
            // this.Grupo = data.data;
            console.log("Fotos Clientes:", data);  
            this.FotoCliente = data.data.foto_beneficiario;

          }
        });

    },

    //Recibir Datos de Otros componentes
    recibirDatosDelHijo(datos) {
      this.cliente = datos; // Manejar los datos recibidos del hijo
      //No funciona
    },


    //Navegar entre Páginas

    //NextPage: Funcion siguiente pagina NO FUNCIONAL POSIBLE BORRAR
    nextPage() {

      if (this.solicitudCompleta.solicitudes[this.solicitudCompleta.integranteSolicitud]) {
        console.log();
      } else {
        this.submitHandler();
      }
      //Se llama la funcion Submit Handler para subir la solicitud



      //Este es cuando es uno que no sea mipyme
      if (
        this.solicitudCompleta.integrantes.length >
        this.solicitudCompleta.integranteSolicitud + 1
      ) {
        this.solicitudCompleta.integranteSolicitud++;

        //Guardar solicitud de integrante

        //Validar Solicitud
      }
    },
    convertirFechaAISO(fechaStr) {
      const fecha = new Date(fechaStr);
      return fecha.toISOString(); // ejemplo: "2025-06-12T00:00:00.000Z"
    },
    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(numero) || 0);
    },
    previousPage() {

      if (this.solicitudCompleta.integranteSolicitud > 0) {
        //Ir para atras en las solicitudes

        this.solicitudCompleta.integranteSolicitud--;
        this.cliente =
          this.solicitudCompleta.integrantes[
          this.solicitudCompleta.integranteSolicitud
          ];
        this.solicitud =
          this.solicitudCompleta.solicitudesObject[
          this.solicitudCompleta.integranteSolicitud
          ]

        // router.push(`/solicitud/integrante/${this.solicitudCompleta.solicitudes[this.solicitudCompleta.integranteSolicitud].id}`);

      } else if (this.productoSeleccionadoNombre !== "Escalonado") {
        router.push("/solicitud");
      } else {
        router.push("/solicitud/grupo-solidario/0");
      }
    },
    buscarPagosEntreFechas(pagos, fechaInicio, fechaFin) {
      const inicio = new Date(fechaInicio);
      const fin = new Date(fechaFin);

      return pagos.filter(pago => {
        const fechaPago = new Date(pago.fecha);
        return fechaPago >= inicio && fechaPago <= fin;
      });
    },
    formatDNI(dni) {
      const cleanedValue = dni.replace(/-/g, "");

      // Aplica el formato con guiones
      let formattedValue = "";
      for (let i = 0; i < cleanedValue.length; i++) {
        if (i === 4 || i === 8) {
          formattedValue += "-";
        }
        formattedValue += cleanedValue[i];
      }

      // Actualiza el valor del input
      return formattedValue;
    },
    formatInput() {
      // Elimina todos los guiones existentes en el valor actual
      const cleanedValue = this.dni.replace(/-/g, "");

      // Aplica el formato con guiones
      let formattedValue = "";
      for (let i = 0; i < cleanedValue.length; i++) {
        if (i === 4 || i === 8) {
          formattedValue += "-";
        }
        formattedValue += cleanedValue[i];
      }

      // Actualiza el valor del input
      this.dni = formattedValue;


    },
    async quitarValidacion() {
      await new Promise(resolve => setTimeout(resolve, 2000));
      const inputElement = document.querySelector('.form-control');

      // Elimina la clase CSS que agrega los estilos no deseados
      inputElement.classList.remove('was-validated');
      inputElement.classList.remove('is-invalid');

      // Sobrescribe los estilos en línea para eliminar los estilos no deseados
      inputElement.style.border = 'none';
      inputElement.style.paddingRight = 'initial';
      inputElement.style.backgroundImage = 'none';
      inputElement.style.backgroundRepeat = 'initial';
      inputElement.style.backgroundPosition = 'initial';
      inputElement.style.backgroundSize = 'initial';
    },

    restaurarSolicitud() {
      const solicitud = {
        ID: 0,
        clienteId: 0,
        producto: "",
        fechaPago: "",
        monto: 0,
        frecuenciaPago: "",
        interes: "",
        tipoPlazo: "",
        plazoPago: 0,
        estado: 'pendiente',
        sucursalId: 0,
        sucursal: '',
        
      };

      return solicitud;
    },
    getCountArchivos(id) {

            fetch(process.env.VUE_APP_API_URL + `/admin/solicitud/count-tipos-archivos/${id}`, Security.requestOptions({}))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        this.$emit('error', response.message);
                        console.error(response.message)


                    } else {

                        console.log('Contador Response:', response.data.data)
                        this.contadorArchivos = response.data.data
                        this.readyArchivos = true
                    }
                })
                .catch(error => {
                    this.$emit('error', error)
                })
        },
    getFirma(id) {

            fetch(process.env.VUE_APP_API_URL + `/admin/firma-digital/get-firma`, Security.requestOptions({solicitudID: id}))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        this.$emit('error', response.message);
                        console.error(response.message)


                    } else {

                        console.log('FIRMA DIGITAL:', response)
                        this.firmaBase64 = response.data.firmaDigital.firma_base64
                        if (this.firmaBase64) {
                          this.autorizadofirma = true
                        }
                        // this.contadorArchivos = response.data.data
                        // this.readyArchivos = true
                    }
                })
                .catch(error => {
                    this.$emit('error', error)
                })
        },
        reloadInfoArchivos(id){

          this.getCountArchivos(id);
        },
        fetchConstitucionActual() {
          return fetch(process.env.VUE_APP_API_URL + "/admin/constitucion/actual", Security.requestOptions({}))
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.$emit("error", response.message);
                return null;
              }

              return response.data?.constitucion || null;
            })
            .catch((error) => {
              this.$emit("error", error);
              return null;
            });
        }
  },
  computed: {
    productoSeleccionadoNombre() {
      return this.getProductoNombre();
    },
    productosSeleccionables() {
      const productoActual = this.getProductoNombre(this.solicitudCompleta.producto || this.solicitud.producto);
      const productosActivos = this.productos.filter((producto) => producto.activo);
      const productosBase = productosActivos.length > 0 ? productosActivos : this.productos;
      const productos = productosBase.map((producto) => ({
        ...producto,
        id: producto.id,
        nombre: producto.nombre,
        activo: producto.activo,
      }));

      if (productoActual && !productos.some((producto) => producto.nombre === productoActual)) {
        const productoExistente = this.productos.find(
          (producto) => this.getProductoNombre(producto).toLowerCase() === productoActual.toLowerCase()
        );
        productos.unshift(productoExistente ? {
          ...productoExistente,
          nombre: this.getProductoNombre(productoExistente),
        } : {
          id: `actual-${productoActual}`,
          nombre: productoActual,
          activo: true,
        });
      }

      return productos;
    },
    noIntegregante() {
      switch (this.solicitudCompleta.integranteSolicitud) {
        case 0:
          return "Primer";
        case 1:
          return "Segundo";
        case 2:
          return "Tercer";
        case 3:
          return "Cuarto";
        case 4:
          return "Quinto";
        default:
          return "Número fuera de rango";
      }
    },
  },
  watch: {
    claseScore(){
      if (this.microCredito()) {
      this.obtenerTasaInteresMicro();
      }
    },
    async reportes(value){
      // console.log(value);
      switch (value) {
        case 'reporte1':
          this.exportarSolicitudPDF('DESCARGA')
          this.reportes = 'Reportes'
          break;
        case 'reporte2':
          if(this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Otorgado'){
            const constitucion = await this.fetchConstitucionActual()
            this.exportacionContratos(this.solicitud, this.cuotaSolicitud, this.comisionOtorgamiento, this.comisionAsistenciaTecnica, this.tasaSeguridad, constitucion)
          }
          this.reportes = 'Reportes'

          break;
        case 'reporte3':
         if(this.solicitud.estado === 'Aprobado' || this.solicitud.estado === 'Otorgado'){
            const constitucion = await this.fetchConstitucionActual()
            exportacionPagares(this.solicitud, this.fechaVencimiento, this.obtenerComisionesProductoSeleccionado(), constitucion)
          }
          this.reportes = 'Reportes'
          break;
        default:
          this.mostrarReporte1 = false
          this.mostrarReporte2 = false
          this.mostrarReporte3 = false
          break;
   
}
    },
    firmaBase64(value) {
      console.log(value);
      if (value) {
        this.autorizadofirma = true
      } 
    },
    arregloPagoIntereses(value) {
      console.log(value);
      if (!value) {
        this.pagosInteres = []
        // this.solicitud.pagosInteres = []
      } else if (value && this.solicitud.pagosInteres.length > 0) {
        this.pagosInteres = this.solicitud.pagosInteres
      }
    },
    pagosInteres: {
      handler(value) {
        console.log(value);
        let sumaMonto = 0;
        for (let i = 0; i < value.length; i++) {
          sumaMonto += value[i].monto;
        }
        sumaMonto = Math.round(sumaMonto * 100) / 100
        console.log("Suma de montos: ", sumaMonto, "Monto a pagar: ", this.montoAPInteres);
        this.validarPagosInteres = sumaMonto == this.montoAPInteres;
      },
      deep: true // Esto es lo que hacía falta
    },
    comisionOtorgamiento: function (comisionOtorgamiento) {
      if (!this.creditrabajo2() && !this.creaFuturo()) {
        this.totalComisionOtorgamiento = this.solicitud.monto * (comisionOtorgamiento / 100)
        this.montoNeto = this.solicitud.monto - this.totalComisionOtorgamiento - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad

      }

    },
    comisionAsistenciaTecnica: function (comisionAsistenciaTecnica) {
      if (!this.creditrabajo2() && !this.creaFuturo()) {
        this.totalComisionAsistenciaTecnica = this.solicitud.monto * (comisionAsistenciaTecnica / 100)
        this.montoNeto = this.solicitud.monto - this.totalComisionOtorgamiento - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad

      }
    },
    tasaSeguridad: function (tasaSeguridad) {
      if (!this.creditrabajo2() && !this.creaFuturo()) {
        this.totalTasaSeguridad = this.solicitud.monto * (tasaSeguridad / 100)
        this.montoNeto = this.solicitud.monto - this.totalComisionOtorgamiento - this.totalComisionAsistenciaTecnica - this.totalTasaSeguridad

      }
    },

    montoOtorgar: function (monto) {
      console.log(monto);
      this.solicitud.montoOtorgar = parseFloat(monto)
    },
    dni(dni) {
      if (Array.from(dni).length == 15) {
        const dniFormatToFetch = dni.replace(/-/g, "");
        
        console.log("Entre en DNI", dniFormatToFetch, this.dniAnterior);
        if(dniFormatToFetch != this.dniAnterior && this.dniAnterior){
          this.store.aprobacion.validacion = false;
          this.solicitudCompleta.integrantes.pop()
        }
        fetch(
          `${process.env.VUE_APP_API_URL}/admin/clientes/dni/${dniFormatToFetch}`,
          Security.requestOptions("")
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
              this.$emit("error", data.message);
            } else {
              this.cliente = data.data;
              this.dniAnterior = this.cliente.dni
              this.solicitudCompleta.integrantes.push(data.data)
              if (
                this.$route.query.validado === "1" &&
                String(this.$route.query.dni || "").replace(/\D/g, "") === this.cliente.dni
              ) {
                this.store.aprobacion.validacion = true;
              }
              this.$emit("datos-hijo-al-padre", data.data);
              console.log(data.data);
            }

            this.FotoBenficiario(this.cliente.dni)

          })
          .catch((error) => {
            this.$emit("error", error);
          });
      } else {
        this.cliente = "";
        this.solicitudCompleta.integrantes.pop()
        // this.mensajeDni = ""
        // dni = document.getElementById('dni');
        // dni.classList.remove('is-invalid')
        // dni.classList.add('was-validated')
      }
      

    },
    'solicitud.garantia': function (garantia) {

      const garantiaContent = document.getElementById('info_garantia')
      if (!garantiaContent) {
        return
      }
      garantiaContent.innerHTML = ''

      if (garantia === "Garantía Fiduciaria") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Documento Nacional de Identificación DNI (Copia Legible).</li>
          <li class="list-group-item">b)	Registro Tributario Nacional o RTN (Copia Legible).</li>
          <li class="list-group-item">c)	Recibo público legible (con un mes de antigüedad).</li>
          <li class="list-group-item">d)	Constancia de Trabajo con deducciones y/o Váucher de pago de los últimos dos meses.</li>
          <li class="list-group-item">e)	Croquis de ubicación de la vivienda y Trabajo, con al menos cinco puntos de referencia.</li>
          <li class="list-group-item">f)	Fotografías de la Vivienda y del Trabajo.  </li>
          <li class="list-group-item">g)	Autorización Irrevocable de Deducción por Planilla (Si aplica). </li>
        </ul>
        `
      } else if (garantia === "Aval Comerciante") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Documento Nacional de Identificación DNI (Copia Legible)</li>
          <li class="list-group-item">b)	Registro Tributario Nacional o RTN (Copia Legible).</li>
          <li class="list-group-item">c)	Relación de ingresos/egresos.</li>
          <li class="list-group-item">d)	Recibo Publico legible (con un mes de antigüedad).</li>
          <li class="list-group-item">e)	Croquis de ubicación de la vivienda y Negocio, con al menos cinco puntos de referencia.</li>
          <li class="list-group-item">f)	Fotografías de la Vivienda y del Negocio. (Debe aparecer OM responsables del crédito)</li>
          <li class="list-group-item">g)	Constancia de verificación de negocio emitida por el OM responsables del Crédito.</li>
          <li class="list-group-item">h)	Referencias familiares o personales.</li>
        </ul>
        `
      } else if (garantia === "Garantía Mobiliaria") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Cotización Original del Equipo y Mobiliario nuevo a adquirir. (Este equipo debe formar parte de la garantía del crédito, sin menoscabo a las demás garantías solicitadas de acuerdo con el análisis de riesgo que presente el crédito).</li>
          <li class="list-group-item">b)	Presentar Factura original o Declaración Jurada de Propiedad del equipo propuesto   en Garantía.</li>
          <li class="list-group-item">c)	Contrato con Garantía Mobiliario.</li>
          <li class="list-group-item">d)	Contrato de subrogación de pagos (Hasta el 80% del valor del contrato).</li>
          <li class="list-group-item">e)	Declaración de garantías mobiliarias y Maquinaria otorgando hasta un máximo de 70% sobre el valor estimado.</li>
        </ul>
        `
      } else if (garantia === "Garantía Prendaria") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Avalúo del Vehículo, realizado por un taller mecánico autorizado por el Comité de Crédito.</li>
          <li class="list-group-item">b)	Documentos Originales del Vehículo.</li>
          <li class="list-group-item">c)	Traspaso del vehículo a favor de AXCC.</li>
          <li class="list-group-item">d)	Solo se aceptarán vehículos de hasta 10 años de antigüedad.</li>
          <li class="list-group-item">e)	La relación crédito/garantía será hasta del 70% del valor de avalúo.</li>
        </ul>
        `
      } else if (garantia === "Garantía Hipotecaria") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Fotocopia de escritura del inmueble que dejará en garantía.</li>
          <li class="list-group-item">b)	Información soporte de la investigación registral en el sistema unificado de registro, para validar el estatus del inmueble. En los casos que el inmueble no tiene matricula en el sistema, se solicitará una constancia de liberación de gravamen.</li>
          <li class="list-group-item">c)	El dominio del inmueble debe ser "Dominio Pleno".</li>
          <li class="list-group-item">d)	Recibo de pago de bienes inmueble vigente o estado de cuenta que refleje que el pago está al día (en la Alcaldía Municipal).</li>
          <li class="list-group-item">e)	Constancia Original de valor catastral emitido por la Alcaldía Municipal.<li>
          <li class="list-group-item">f)	Avalúo del bien inmueble (Elaborado por valuador vigente y autorizado por AXCC e inscrito en la Comisión Nacional de Bancos y Seguros).<li>
          <li class="list-group-item">g)	Recibo de la ENEE y SANAA del inmueble propuesto en garantía.<li>
          <li class="list-group-item">h)	Para inmuebles urbanos la relación préstamo/garantía será hasta un 80% del valor del avalúo y para inmuebles rurales hasta el 70% del valor del avalúo.<li>
          <li class="list-group-item">i)	Copia del Recibo de presentación en el registro de la Propiedad del Testimonio de escritura con la hipoteca del inmueble a favor de AXCC.<li>
        </ul>
        `
      } else if (garantia === "Grupo Solidario") {
        garantiaContent.innerHTML = `
        <ul class="list-group">
          <li class="list-group-item">a)	Deberá estar conformado por grupos de beneficiarios de 2 a 5 integrantes, formados de manera voluntaria y que sean afines; los cuales deberán avalarse mutuamente y acceder a un crédito.</li>
          <li class="list-group-item">b)	Estar constituidos formalmente por Acta de constitución de Grupo (Ver anexo), debidamente firmada por los integrantes en la cual los integrantes manifiesten tener confianza entre sí y avalarse solidariamente.</li>
          <li class="list-group-item">c)	Los integrantes del grupo solidario deben ser ciudadanos hondureños por nacimiento naturalizados, con domicilio en el territorio nacional y encontrarse en el pleno ejercicio de sus derechos civiles.</li>
          <li class="list-group-item">d)	Se podrá otorgar créditos a jóvenes comprendidos entre los 18 y 21 años en cualquiera de las formas siguientes:
              <ul class="list-group">
                <li class="list-group-item">  a.	Quienes se hayan emancipado, ya sea por constituirse como comerciante o por haber contraído matrimonio. (Presentar constancia extendida por el RNP). </li>
                  <li class="list-group-item">  b.	Con autorización de los padres o representantes legales en instrumento público o interviniendo el mismo expresa y directamente en el acto (firmando el contrato de crédito).</li>
                    <li class="list-group-item">  c.	Tener un Coordinador o Presidente del Grupo Solidario el cual deberá ser elegido democráticamente por los demás integrantes.</li>
              </ul>
            </li>
        </ul>
        `
      }

    },
    'solicitud.estado': function (estado) {
      const userRoles = Security.getUserRoles();
      const formulario = document.getElementById('cliente-form');
      const inputs = formulario.querySelectorAll('input')

      const selects = formulario.querySelectorAll('select')
      const textareas = formulario.querySelectorAll('textarea')
      if (estado === 'Aprobado' || estado === 'Otorgado') {
        inputs.forEach(input => {
          input.disabled = true;
        })
        selects.forEach(select => {
          select.disabled = true;
        })
        textareas.forEach(textarea => {
          textarea.disabled = true;
        })
        document.getElementById('fecha').disabled = false
      }
      if (estado === 'Aprobado' || estado === 'Otorgado') {

        inputs.forEach(input => {
          if (input.classList.contains('referencia-control')) {
            input.disabled = false;
          }
        })
        selects.forEach(select => {
          if (select.name === 'garantia' || select.name === 'reportes' || select.classList.contains('referencia-control')) {
            select.disabled = false;
          } else {
            select.disabled = true;
          }
        })
        textareas.forEach(textarea => {
          textarea.classList.contains('referencia-control') ? textarea.disabled = false : textarea.disabled = true;
        })
        document.getElementById('fecha').disabled = false
      }
      if (userRoles[0]?.some(role => role.includes('Modo Thanos')) === true) {
        document.getElementById('fecha').disabled = true
        inputs.forEach(input => {
          input.disabled = false;
        })
        selects.forEach(select => {
          select.disabled = false;
        })
        textareas.forEach(textarea => {
          textarea.disabled = false;
        })
      }
    },
    'solicitud.monto': function () {
      if (this.microCredito()) {
        this.onBlur()
      }
    },
    'solicitud.plazoPago': function (plazo) {
      console.log(plazo);
      this.onBlur()
      if (this.creditrabajo2()) {

        console.log("CRÉDITO DE TRABAJO 2");
        switch (plazo) {
          case 1:
            this.solicitud.interes = 12
            this.comisionOtorgamiento = 4.27
            this.comisionAsistenciaTecnica = 3.80
            this.tasaSeguridad = 0.40
            break;
          case 2:
            this.solicitud.interes = 8.16
            this.comisionOtorgamiento = 4.08
            this.comisionAsistenciaTecnica = 3.62
            this.tasaSeguridad = 0.40
            break;
          case 3:
            this.solicitud.interes = 22.56
            this.comisionOtorgamiento = 3.9
            this.comisionAsistenciaTecnica = 3.47
            this.tasaSeguridad = 0.40
            break;
          case 4:
            this.solicitud.interes = 28.68
            this.comisionOtorgamiento = 3.74
            this.comisionAsistenciaTecnica = 3.32
            this.tasaSeguridad = 0.40
            break;
          case 5:
            this.solicitud.interes = 31.56
            this.comisionOtorgamiento = 3.59
            this.comisionAsistenciaTecnica = 3.19
            this.tasaSeguridad = 0.40
            break;
          case 6:
            this.solicitud.interes = 33
            this.comisionOtorgamiento = 3.9
            this.comisionAsistenciaTecnica = 3.47
            this.tasaSeguridad = 0.40
            break;
          default:
            this.solicitud.interes = 12
            this.comisionOtorgamiento = 4.27
            this.comisionAsistenciaTecnica = 3.80
            this.tasaSeguridad = 0.40
            break;
        }

      } else if (this.creaFuturo()) {
        //Parece que no se usa


        // this.solicitud.interes = 12
        this.comisionOtorgamiento = 3.5
        this.comisionAsistenciaTecnica = 4.5
        this.tasaSeguridad = 0.2
        this.reservasSeguros = 1.6
        this.consultasBuro = 0.2
        // this.solicitud.interes = 12
        //     this.comisionOtorgamiento = 2.5
        //     this.comisionAsistenciaTecnica = 3.5
        //     this.tasaSeguridad = 0.2
      } 
      




    },

  },
  
};
</script>

<style scoped>
.dashboard-shell {
  background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.solicitud-card-body {
  padding: 0;
}

.dashboard-header {
  background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
  border-radius: 18px;
  color: #fff;
  padding: 14px 16px;
}

.dashboard-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.solicitud-subtitle {
  color: #e5e7eb;
  font-size: 0.95rem;
}

.solicitud-badge {
  display: inline-block;
  border: 1px solid #e5e7eb66;
  border-radius: 999px;
  padding: 0.3rem 0.75rem;
  color: #f9fafb;
  font-size: 0.85rem;
}

.solicitud-main-btn {
  border-radius: 999px;
  font-weight: 600;
}

.report-select {
  min-width: 220px;
  max-width: 320px;
}

.solicitud-accordion {
  border-radius: 18px !important;
}

.solicitud-accordion .accordion-item {
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px !important;
  overflow: hidden !important;
  margin-bottom: 12px !important;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06) !important;
}

.solicitud-accordion .accordion-header {
  border-radius: 14px !important;
}

.solicitud-accordion .accordion-button {
  background: linear-gradient(120deg, #f8fafc 0%, #eef2ff 100%) !important;
  color: #111827 !important;
  font-weight: 700 !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0.9rem 1rem !important;
}

.solicitud-accordion .accordion-button:not(.collapsed) {
  background: linear-gradient(120deg, #111827 0%, #1f2937 100%) !important;
  color: #f9fafb !important;
}

.solicitud-accordion .accordion-button::after {
  filter: grayscale(0.2) contrast(1.2) !important;
}

.solicitud-accordion .accordion-button:not(.collapsed)::after {
  filter: brightness(2.5) !important;
}

.solicitud-accordion .accordion-body {
  background: #ffffff !important;
  padding: 1rem !important;
}

.custom-table {
  outline: none;
  border: none;
  margin: 0px;
  padding: 0px;
  border-collapse: collapse;

  >tbody>tr>td {
    margin: 0px;
    padding: 0px;
    border: none;
    vertical-align: middle;

    .control {
      text-align: left;
      font-size: 1rem;
    }
  }
}

.btnOptionSolicitud {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-wrap: wrap;
}

.card {
  border-radius: 12px;
  border: 1px solid #eef2f6;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
  border-top: none;
  border-left: none;
  border: 1px solid #eef2f6;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
  border-top: none;
  border-left: none;
}

/* .form-control {
  border-radius: 10px;
  height: 70%;
  
} */

/* .form-control:focus {
  border-color: #ff9100;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
} */

/* Sombra */
.col-form-label {
  margin: 0px !important;
}

.form-group {
  margin-bottom: 0px;
}

.form-group {
  margin-block: 8px;
}

.col-form-label {
  padding-left: 10px;
  padding-right: 5px;
}

.card-description {
  margin-block: 15px;
}

.solicitud-info-layout {
  display: grid;
  grid-template-columns: minmax(280px, 0.9fr) minmax(360px, 1.25fr);
  gap: 18px;
  align-items: start;
}

.solicitud-info-panel {
  border: 1px solid #dbe4ef;
  border-radius: 8px;
  padding: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.garantia-panel {
  border-top: 4px solid #0f766e;
}

.referencias-panel {
  border-top: 4px solid #2563eb;
}

.solicitud-info-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.solicitud-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  color: #0f766e;
  background: #dff8f2;
  flex: 0 0 auto;
}

.referencias-icon {
  color: #1d4ed8;
  background: #e0ecff;
}

.solicitud-info-kicker {
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.solicitud-info-title,
.referencia-title {
  color: #111827;
  font-weight: 800;
}

.solicitud-info-label {
  color: #334155;
  font-weight: 700;
  font-size: 0.86rem;
}

.solicitud-info-select,
.referencia-control {
  border-color: #cbd5e1;
  border-radius: 8px;
  background-color: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.solicitud-info-select:focus,
.referencia-control:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 0.18rem rgba(37, 99, 235, 0.14);
}

.garantia-requisitos {
  margin-top: 16px;
  border: 1px solid #d9f0ea;
  border-radius: 8px;
  padding: 14px;
  background: #f3fbf8;
}

.garantia-requisitos-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0f766e;
  font-size: 0.9rem;
}

#info_garantia .list-group {
  gap: 8px;
}

#info_garantia .list-group-item {
  border: 1px solid #dbe4ef;
  border-radius: 8px;
  color: #334155;
  font-size: 0.86rem;
  line-height: 1.35;
  padding: 10px 12px;
  background: #ffffff;
}

.add-referencia-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 8px;
  padding: 8px 12px;
  color: #ffffff;
  font-weight: 700;
  background: #2563eb;
  box-shadow: 0 8px 16px rgba(37, 99, 235, 0.2);
}

.add-referencia-btn:hover,
.add-referencia-btn:focus {
  color: #ffffff;
  background: #1d4ed8;
}

.referencia-box {
  border: 1px solid #dbe4ef;
  border-radius: 8px;
  padding: 14px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
}

.referencia-box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.referencia-number {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #0f172a;
}

.referencia-number span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  color: #1d4ed8;
  font-weight: 800;
  background: #e0ecff;
}

.remove-referencia-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: #b91c1c;
  background: #fee2e2;
}

.remove-referencia-btn:hover,
.remove-referencia-btn:focus {
  color: #ffffff;
  background: #dc2626;
}

@media (max-width: 992px) {
  .solicitud-info-layout {
    grid-template-columns: 1fr;
  }
}


.btnn {
  /* background-color: aqua; */
  border-radius: 50px;
  width: 50px;
  height: 50px;
}

.btnn p {
  margin-bottom: 0px;
  color: white;
}

.plan-inversión {
  /* width: 50%; */
  /* border-collapse: collapse; */
  margin-bottom: 20px;
}

.plan-inversión,
th,
td {
  border: 1px solid black;
  text-align: center;
}

th,
td {
  padding: 10px;
  vertical-align: top;
  /* Alinea el contenido en la parte superior de las celdas */
}

.input-plan {
  width: 100%;
  box-sizing: border-box;
  border: none;
  /* Elimina los bordes de los inputs */
  outline: none;
  /* Elimina el contorno al hacer clic en los inputs */
}

.table-container {
  width: 70%;
}

.custom-table {
  border-collapse: collapse;
  width: 100%;
}

.custom-table th,
.custom-table td {
  border: 1px solid black;
  padding: 10px;
  text-align: center;
  vertical-align: top;
}

.custom-input {
  width: 100%;
  box-sizing: border-box;
  border: none;
  outline: none;
}

@media (max-width: 767px) {
  .cardplay {
    padding: 15px;
  }

  .report-select {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 767px) {
  .cardplay {
    padding: 15px;
  }

  .report-select {
    width: 100%;
    max-width: 100%;
  }
}
</style>

<style>
.carta {
  border-radius: 12px;

  /* border-left-color: #4285f4; */
  /* border-top: 5px solid #00ff0d88; */
  /* border-left: 5px solid #ffea0667; */
  >.row {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
}

@media screen and (max-width: 768px) {
  .carta {
    >.row {
      flex-direction: column;

      >div {
        width: 100%;
      }
    }
  }

}

.fm {
  border-radius: 10px;
  height: 70%;
}

.fm:focus {
  border-color: #ff9100;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  /* Sombra */
}

.pad {
  /* padding-left: 5px; */
  padding-inline: 5px !important;
}

.bounce {
  -webkit-animation-name: bounce;
  animation-name: bounce;
  -webkit-transform-origin: center bottom;
  -ms-transform-origin: center bottom;
  transform-origin: center bottom;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounce {

  0%,
  20%,
  53%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0);
  }

  70% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0);
  }
}

@keyframes bounce {

  0%,
  20%,
  53%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -30px, 0);
    transform: translate3d(0, -30px, 0);
  }

  70% {
    -webkit-transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(0, -15px, 0);
    transform: translate3d(0, -15px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -4px, 0);
    transform: translate3d(0, -4px, 0);
  }
}
</style>


<!-- Estilos tabla de amortizacion -->

<style>
#contenedor-plan,
#contenedorTabla {
  background-color: #FFF;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  overflow: auto;
  width: 100%;
  max-width: 100%;

  >.header {
    width: 100%;

  }
}

/* #contenedorTabla {
  width: 100%;
  max-height: 80%;
  overflow-y: hidden;
  overflow-x: auto;
} */


.table-plan {
  border: 2px solid royalblue;
  border-collapse: collapse;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  font-family: inherit;
  font-size: 0.9em;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

.table-plan thead tr {
  background: royalblue;
  color: white;
  text-align: left;
  font-weight: bold;
}

.table-plan thead,
td {
  padding: 12px 15px;
}

.table-plan tbody tr {
  border-bottom: 1px solid #F0F0F0;
}

.table-plan tbody tr:nth-last-of-type(even) {
  background-color: #F3F3F3;
}

.table-plan tbody tr:last-of-type {
  border-bottom: 2px solid royalblue;
}

.table-plan tbody tr:hover {
  color: white;
  background: rgba(65, 105, 225, 90%);
}

.table-plan tfoot {
  background: royalblue;
  color: white;
}
</style>


<!-- Estilos formularios  -->

<style scoped>
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: royalblue;
}

.header,
thead {
  border-bottom: 1px solid #F0F0F0;
  background-color: #F7F7F7;
  padding: 20px 40px;
}

.header h2 {
  margin: 0;
  width: 100%;
}

#frmPrestamo {
  padding: 30px 40px;
}

#frmPrestamo .control,
#amortizaciones .control,
.radios {
  margin-bottom: 10px;
  padding-bottom: 20px;
  position: relative;
}

#frmPrestamo .control label {
  margin-bottom: 5px;
}

#frmPrestamo .control input,
#frmPrestamo .control select {
  border: 2px solid #F0F0F0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  padding: 10px;
  width: 100%;
}

#frmPrestamo .control input:focus {
  outline: 0;
  border-color: royalblue;
}

#frmPrestamo button {
  background: rgba(65, 105, 225, 90%);
  border: 2px solid royalblue;
  border-radius: 4px;
  color: #FFF;
  display: block;
  font-family: inherit;
  font-size: medium;
  padding: 10px;
  margin-top: 20px;
  width: 100%;
}

.radios {
  padding: 10px 20px;
}

.radioContenedor {
  display: inline-block;
  position: relative;
  cursor: pointer;
  user-select: none;
  padding-left: 30px;
  margin: 10px;
}

.radioContenedor input {
  display: none;
}

.radioContenedor .circle {
  left: 0;
  top: 0;
  width: 25px;
  height: 25px;
  border-radius: 50px;
  position: absolute;
  display: inline-block;
  background-color: rgba(65, 105, 225, 90%);
  border-bottom: 2px solid royalblue;
}

.radioContenedor:hover .circle {
  background-color: royalblue;
}

.radioContenedor input:checked+.circle {
  background-color: royalblue;
}

.radioContenedor input:checked+.circle:after {
  content: '';
  height: 10px;
  width: 10px;
  background-color: white;
  position: absolute;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.fa-star {
  color: #fff200;
}

.form-group {
  background-color: #f5f5f5f5;
  border-radius: 10px;
  margin-left: 10px;
  width: 97%;
}

p {
  margin: 0;
}

.btn {
  color: white;
  /* width: 100px; */
}

.arreglo-pago-interes {

  background-color: #f0f0f0;
  border-radius: 5px;
  padding: 10px;
}


@media (max-width: 768px) {
  .accordion-body{
  padding: 10px;
}
#frmPrestamo{
  padding: 10px;
}
.card-body{
  padding: 10px;
}
.content-wrapper{
  padding: 10px;
}
}

.sin-foto{
  width: 130px;
  height: 170px;
  border-radius: 5px;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #757575;
  font-size: 60px;
  text-align: center;
}

.extra-info{
  /* background-color: #ff9100; */
}
.extra-info:hover{
  background-color: #d9d9d9;
}

.row > * {

    margin-block: 5px !important;
}
</style>
